var map = {
	"./AboutPublishingCarousel": 1518,
	"./AboutPublishingCarousel.js": 1518,
	"./AboutPublishingCarousel/Main": 1519,
	"./AboutPublishingCarousel/Main.jsx": 1519,
	"./AboutPublishingCarousel/Quote": 367,
	"./AboutPublishingCarousel/Quote.jsx": 367,
	"./AddQualificationModal/AddQualificationModal": 215,
	"./AddQualificationModal/AddQualificationModal.jsx": 215,
	"./AddQualificationModal/Main": 933,
	"./AddQualificationModal/Main.jsx": 933,
	"./Admin/Channels/Index/ArticleOverviewTable": 1801,
	"./Admin/Channels/Index/ArticleOverviewTable.jsx": 1801,
	"./Admin/Channels/Index/Articles": 952,
	"./Admin/Channels/Index/Articles.jsx": 952,
	"./Admin/Channels/Index/ArticlesTable/BaseTable": 72,
	"./Admin/Channels/Index/ArticlesTable/BaseTable.jsx": 72,
	"./Admin/Channels/Index/ArticlesTable/ChannelRemoved": 956,
	"./Admin/Channels/Index/ArticlesTable/ChannelRemoved.jsx": 956,
	"./Admin/Channels/Index/ArticlesTable/ClaimExpired": 957,
	"./Admin/Channels/Index/ArticlesTable/ClaimExpired.jsx": 957,
	"./Admin/Channels/Index/ArticlesTable/EditorApproval": 955,
	"./Admin/Channels/Index/ArticlesTable/EditorApproval.jsx": 955,
	"./Admin/Channels/Index/ArticlesTable/EditorPreview": 953,
	"./Admin/Channels/Index/ArticlesTable/EditorPreview.jsx": 953,
	"./Admin/Channels/Index/ArticlesTable/InRereview": 1802,
	"./Admin/Channels/Index/ArticlesTable/InRereview.jsx": 1802,
	"./Admin/Channels/Index/ArticlesTable/InReview": 954,
	"./Admin/Channels/Index/ArticlesTable/InReview.jsx": 954,
	"./Admin/Channels/Index/ArticlesTableSection": 555,
	"./Admin/Channels/Index/ArticlesTableSection.jsx": 555,
	"./Admin/Channels/Index/ChannelAdminEditors": 958,
	"./Admin/Channels/Index/ChannelAdminEditors.jsx": 958,
	"./Admin/Channels/Index/ChannelCard": 959,
	"./Admin/Channels/Index/ChannelCard.jsx": 959,
	"./Admin/Channels/Index/ChannelEditorApprovalActivity": 961,
	"./Admin/Channels/Index/ChannelEditorApprovalActivity.jsx": 961,
	"./Admin/Channels/Index/ChannelEditorPreviewActivity": 962,
	"./Admin/Channels/Index/ChannelEditorPreviewActivity.jsx": 962,
	"./Admin/Channels/Index/ChannelsList": 963,
	"./Admin/Channels/Index/ChannelsList.jsx": 963,
	"./Admin/Channels/Index/CopyEmails": 960,
	"./Admin/Channels/Index/CopyEmails.jsx": 960,
	"./Admin/Channels/Index/EditorCheckActivity": 965,
	"./Admin/Channels/Index/EditorCheckActivity.jsx": 965,
	"./Admin/Channels/Index/EditorColumn": 556,
	"./Admin/Channels/Index/EditorColumn.jsx": 556,
	"./Admin/Channels/Index/InProgress": 966,
	"./Admin/Channels/Index/InProgress.jsx": 966,
	"./Admin/Channels/Index/InProgressOverview": 968,
	"./Admin/Channels/Index/InProgressOverview.jsx": 968,
	"./Admin/Channels/Index/Main": 1803,
	"./Admin/Channels/Index/Main.jsx": 1803,
	"./Admin/Channels/Index/MainMetrics": 967,
	"./Admin/Channels/Index/MainMetrics.jsx": 967,
	"./Admin/Channels/Index/Performance": 969,
	"./Admin/Channels/Index/Performance.jsx": 969,
	"./Admin/Channels/Index/SortButton": 964,
	"./Admin/Channels/Index/SortButton.jsx": 964,
	"./Admin/Channels/Index/shared": 155,
	"./Admin/Channels/Index/shared.js": 155,
	"./AdminAffiliations": 1804,
	"./AdminAffiliations.js": 1804,
	"./AdminAffiliations/CleanAffiliations": 970,
	"./AdminAffiliations/CleanAffiliations.jsx": 970,
	"./AdminAffiliations/EditModal": 557,
	"./AdminAffiliations/EditModal.jsx": 557,
	"./AdminAffiliations/Main": 1805,
	"./AdminAffiliations/Main.jsx": 1805,
	"./AdminArticleAvailableReviewers": 1806,
	"./AdminArticleAvailableReviewers.js": 1806,
	"./AdminArticleAvailableReviewers/Main": 1807,
	"./AdminArticleAvailableReviewers/Main.jsx": 1807,
	"./AdminArticleAvailableReviewers/Row": 972,
	"./AdminArticleAvailableReviewers/Row.jsx": 972,
	"./AdminArticleAvailableReviewers/Search": 973,
	"./AdminArticleAvailableReviewers/Search.jsx": 973,
	"./AdminArticleAvailableReviewers/Table": 971,
	"./AdminArticleAvailableReviewers/Table.jsx": 971,
	"./AdminArticleComments": 1808,
	"./AdminArticleComments.js": 1808,
	"./AdminArticleComments/FlagModal": 987,
	"./AdminArticleComments/FlagModal.jsx": 987,
	"./AdminArticleComments/FlagRow": 989,
	"./AdminArticleComments/FlagRow.jsx": 989,
	"./AdminArticleComments/Main": 1809,
	"./AdminArticleComments/Main.jsx": 1809,
	"./AdminArticleComments/Row": 988,
	"./AdminArticleComments/Row.jsx": 988,
	"./AdminArticleDesign/Main": 1810,
	"./AdminArticleDesign/Main.jsx": 1810,
	"./AdminArticleDesign/Promotion": 991,
	"./AdminArticleDesign/Promotion.jsx": 991,
	"./AdminArticleDesign/Sidebar": 990,
	"./AdminArticleDesign/Sidebar.jsx": 990,
	"./AdminArticleReviewers": 1811,
	"./AdminArticleReviewers.js": 1811,
	"./AdminArticleReviewers/ApprovalEditorRejectReviewModal": 992,
	"./AdminArticleReviewers/ApprovalEditorRejectReviewModal.jsx": 992,
	"./AdminArticleReviewers/DeleteReviewersModal": 993,
	"./AdminArticleReviewers/DeleteReviewersModal.jsx": 993,
	"./AdminArticleReviewers/HistoryModal": 994,
	"./AdminArticleReviewers/HistoryModal.jsx": 994,
	"./AdminArticleReviewers/Main": 1812,
	"./AdminArticleReviewers/Main.jsx": 1812,
	"./AdminArticleReviewers/RejectReviewModal": 997,
	"./AdminArticleReviewers/RejectReviewModal.jsx": 997,
	"./AdminArticleReviewers/RejectedModal": 998,
	"./AdminArticleReviewers/RejectedModal.jsx": 998,
	"./AdminArticleReviewers/Row": 995,
	"./AdminArticleReviewers/Row.jsx": 995,
	"./AdminArticleReviewers/ThoughtsModal": 996,
	"./AdminArticleReviewers/ThoughtsModal.jsx": 996,
	"./AdminAuthorStatsTable": 1813,
	"./AdminAuthorStatsTable.js": 1813,
	"./AdminAuthorStatsTable/ArticleStatsRow": 999,
	"./AdminAuthorStatsTable/ArticleStatsRow.jsx": 999,
	"./AdminAuthorStatsTable/BanModal": 1000,
	"./AdminAuthorStatsTable/BanModal.jsx": 1000,
	"./AdminAuthorStatsTable/FlagModal": 1001,
	"./AdminAuthorStatsTable/FlagModal.jsx": 1001,
	"./AdminAuthorStatsTable/Main": 1814,
	"./AdminAuthorStatsTable/Main.jsx": 1814,
	"./AdminAuthorStatsTable/Row": 1002,
	"./AdminAuthorStatsTable/Row.jsx": 1002,
	"./AdminBrowseSpecialtyDesign/Main": 1815,
	"./AdminBrowseSpecialtyDesign/Main.jsx": 1815,
	"./AdminBrowseSpecialtyDesign/Promotion": 558,
	"./AdminBrowseSpecialtyDesign/Promotion.jsx": 558,
	"./AdminBrowseSpecialtyDesign/Sidebar": 1003,
	"./AdminBrowseSpecialtyDesign/Sidebar.jsx": 1003,
	"./AdminCollectionApplications/ApproveModal": 322,
	"./AdminCollectionApplications/ApproveModal.jsx": 322,
	"./AdminCollectionApplications/Main": 1816,
	"./AdminCollectionApplications/Main.jsx": 1816,
	"./AdminCollectionApplications/NewTable": 1004,
	"./AdminCollectionApplications/NewTable.jsx": 1004,
	"./AdminCollectionApplications/RejectModal": 323,
	"./AdminCollectionApplications/RejectModal.jsx": 323,
	"./AdminCollectionApplications/RejectedApprovedTable": 1005,
	"./AdminCollectionApplications/RejectedApprovedTable.jsx": 1005,
	"./AdminCollectionApplications/Show": 1817,
	"./AdminCollectionApplications/Show.jsx": 1817,
	"./AdminCollections/CollectionArticles/Main": 1818,
	"./AdminCollections/CollectionArticles/Main.jsx": 1818,
	"./AdminCollections/CollectionTable": 1006,
	"./AdminCollections/CollectionTable.jsx": 1006,
	"./AdminCollections/CureusCurated": 1008,
	"./AdminCollections/CureusCurated.jsx": 1008,
	"./AdminCollections/GuestEditor": 1009,
	"./AdminCollections/GuestEditor.jsx": 1009,
	"./AdminCollections/GuestEditorActions/Main": 1819,
	"./AdminCollections/GuestEditorActions/Main.jsx": 1819,
	"./AdminCollections/GuestEditorActions/Table": 559,
	"./AdminCollections/GuestEditorActions/Table.jsx": 559,
	"./AdminCollections/GuestEditorDraftTable": 1010,
	"./AdminCollections/GuestEditorDraftTable.jsx": 1010,
	"./AdminCollections/GuestEditorTable": 1011,
	"./AdminCollections/GuestEditorTable.jsx": 1011,
	"./AdminCollections/Main": 1820,
	"./AdminCollections/Main.jsx": 1820,
	"./AdminDeferralReasons": 1821,
	"./AdminDeferralReasons.js": 1821,
	"./AdminDeferralReasons/DeleteModal": 1012,
	"./AdminDeferralReasons/DeleteModal.jsx": 1012,
	"./AdminDeferralReasons/EditModal": 1013,
	"./AdminDeferralReasons/EditModal.jsx": 1013,
	"./AdminDeferralReasons/Main": 1822,
	"./AdminDeferralReasons/Main.jsx": 1822,
	"./AdminDeferralReasons/NewModal": 1015,
	"./AdminDeferralReasons/NewModal.jsx": 1015,
	"./AdminDeferralReasons/Row": 1014,
	"./AdminDeferralReasons/Row.jsx": 1014,
	"./AdminDeskRejections/DeskRejectModal": 1016,
	"./AdminDeskRejections/DeskRejectModal.jsx": 1016,
	"./AdminDeskRejections/Main": 1823,
	"./AdminDeskRejections/Main.jsx": 1823,
	"./AdminDiscounts/Index": 1824,
	"./AdminDiscounts/Index.jsx": 1824,
	"./AdminEmailReminder/AdminEditorCheckboxes": 948,
	"./AdminEmailReminder/AdminEditorCheckboxes.jsx": 948,
	"./AdminEmailReminder/AuthorCheckboxes": 949,
	"./AdminEmailReminder/AuthorCheckboxes.jsx": 949,
	"./AdminEmailReminder/AuthorsReminderModal": 1467,
	"./AdminEmailReminder/AuthorsReminderModal.jsx": 1467,
	"./AdminEmailReminder/Checkbox": 254,
	"./AdminEmailReminder/Checkbox.jsx": 254,
	"./AdminEmailReminder/EditorPreviewApprovalReminderModal": 1466,
	"./AdminEmailReminder/EditorPreviewApprovalReminderModal.jsx": 1466,
	"./AdminEmailReminder/EmailReminderModal": 233,
	"./AdminEmailReminder/EmailReminderModal.jsx": 233,
	"./AdminEmailReminder/Main": 1825,
	"./AdminEmailReminder/Main.jsx": 1825,
	"./AdminEmailReminder/RecipientCheckboxes": 318,
	"./AdminEmailReminder/RecipientCheckboxes.jsx": 318,
	"./AdminHomepage/HeroTest": 934,
	"./AdminHomepage/HeroTest.jsx": 934,
	"./AdminHomepage/Main": 935,
	"./AdminHomepage/Main.jsx": 935,
	"./AdminHomepage/MainContent": 216,
	"./AdminHomepage/MainContent.jsx": 216,
	"./AdminHomepage/Sidebar": 223,
	"./AdminHomepage/Sidebar.jsx": 223,
	"./AdminInsideCureusArticles": 1826,
	"./AdminInsideCureusArticles.js": 1826,
	"./AdminInsideCureusArticles/Main": 1827,
	"./AdminInsideCureusArticles/Main.jsx": 1827,
	"./AdminInvoices": 1828,
	"./AdminInvoices.js": 1828,
	"./AdminInvoices/EditorialActivity": 1017,
	"./AdminInvoices/EditorialActivity.jsx": 1017,
	"./AdminInvoices/InvoiceTool": 1018,
	"./AdminInvoices/InvoiceTool.jsx": 1018,
	"./AdminInvoices/Main": 1829,
	"./AdminInvoices/Main.jsx": 1829,
	"./AdminInvoices/TotalEarningsTable": 1019,
	"./AdminInvoices/TotalEarningsTable.jsx": 1019,
	"./AdminInvoices/UpdateMiscItemModal": 1020,
	"./AdminInvoices/UpdateMiscItemModal.jsx": 1020,
	"./AdminMessageTable": 1830,
	"./AdminMessageTable.js": 1830,
	"./AdminMessageTable/ConfirmationModal": 1021,
	"./AdminMessageTable/ConfirmationModal.jsx": 1021,
	"./AdminMessageTable/EditMessageModal": 1022,
	"./AdminMessageTable/EditMessageModal.jsx": 1022,
	"./AdminMessageTable/Main": 1831,
	"./AdminMessageTable/Main.jsx": 1831,
	"./AdminMessageTable/MessageModal": 1832,
	"./AdminMessageTable/MessageModal.jsx": 1832,
	"./AdminMessageTable/Row": 1023,
	"./AdminMessageTable/Row.jsx": 1023,
	"./AdminResourceHistory": 1833,
	"./AdminResourceHistory.js": 1833,
	"./AdminResourceHistory/HistoryModal": 1024,
	"./AdminResourceHistory/HistoryModal.jsx": 1024,
	"./AdminResourceHistory/Main": 1834,
	"./AdminResourceHistory/Main.jsx": 1834,
	"./AdminUnwantedAccounts/BlackListTermCell": 1025,
	"./AdminUnwantedAccounts/BlackListTermCell.jsx": 1025,
	"./AdminUnwantedAccounts/EditTermModal": 1026,
	"./AdminUnwantedAccounts/EditTermModal.jsx": 1026,
	"./AdminUnwantedAccounts/Main": 1835,
	"./AdminUnwantedAccounts/Main.jsx": 1835,
	"./AdminUnwantedAccounts/NewTermModals": 324,
	"./AdminUnwantedAccounts/NewTermModals.jsx": 324,
	"./AdminUnwantedAccounts/Table": 1027,
	"./AdminUnwantedAccounts/Table.jsx": 1027,
	"./AdminUnwantedAccounts/UploadTermsModal": 1028,
	"./AdminUnwantedAccounts/UploadTermsModal.jsx": 1028,
	"./AdminUsers": 1836,
	"./AdminUsers.js": 1836,
	"./AdminUsers/Availability": 1837,
	"./AdminUsers/Availability.jsx": 1837,
	"./AdminUsers/FlaggedUsers": 1838,
	"./AdminUsers/FlaggedUsers.jsx": 1838,
	"./AdminUsers/Goals": 1839,
	"./AdminUsers/Goals.jsx": 1839,
	"./AdminUsers/GoogleCalendarEventAddModal": 1029,
	"./AdminUsers/GoogleCalendarEventAddModal.jsx": 1029,
	"./AdminUsers/Heatmap": 1840,
	"./AdminUsers/Heatmap.jsx": 1840,
	"./AdminUsers/Main": 1841,
	"./AdminUsers/Main.jsx": 1841,
	"./AdminUsers/MessageBoard": 1842,
	"./AdminUsers/MessageBoard.jsx": 1842,
	"./AdvisorTiles": 1843,
	"./AdvisorTiles.js": 1843,
	"./AdvisorTiles/Main": 1844,
	"./AdvisorTiles/Main.jsx": 1844,
	"./AdvisorTiles/Tile": 1030,
	"./AdvisorTiles/Tile.jsx": 1030,
	"./AllChannels/Card": 1031,
	"./AllChannels/Card.jsx": 1031,
	"./AllChannels/ChannelView": 1032,
	"./AllChannels/ChannelView.jsx": 1032,
	"./AllChannels/Index": 1845,
	"./AllChannels/Index.jsx": 1845,
	"./AllChannels/ToggleViewButton": 1033,
	"./AllChannels/ToggleViewButton.jsx": 1033,
	"./AnimalSubjects": 1846,
	"./AnimalSubjects.js": 1846,
	"./AnimalSubjects/Validator": 1847,
	"./AnimalSubjects/Validator.jsx": 1847,
	"./ApprovalEditorCompletions/Index": 1848,
	"./ApprovalEditorCompletions/Index.jsx": 1848,
	"./ApprovalEditorCompletions/ListTab": 1035,
	"./ApprovalEditorCompletions/ListTab.jsx": 1035,
	"./ApprovalEditorCompletions/MonthlyTab": 1036,
	"./ApprovalEditorCompletions/MonthlyTab.jsx": 1036,
	"./ApprovalEditorCompletions/ScoresDistribution": 1037,
	"./ApprovalEditorCompletions/ScoresDistribution.jsx": 1037,
	"./ApprovalEditorSuite/ActivityLog": 1038,
	"./ApprovalEditorSuite/ActivityLog.jsx": 1038,
	"./ApprovalEditorSuite/AddNoteModal": 1040,
	"./ApprovalEditorSuite/AddNoteModal.jsx": 1040,
	"./ApprovalEditorSuite/AeHistoryModal": 1039,
	"./ApprovalEditorSuite/AeHistoryModal.jsx": 1039,
	"./ApprovalEditorSuite/Concern": 1041,
	"./ApprovalEditorSuite/Concern.jsx": 1041,
	"./ApprovalEditorSuite/Main": 1849,
	"./ApprovalEditorSuite/Main.jsx": 1849,
	"./ApprovalEditorSuite/Other": 1046,
	"./ApprovalEditorSuite/Other.jsx": 1046,
	"./ApprovalEditorSuite/Performance/PerformanceSection": 1044,
	"./ApprovalEditorSuite/Performance/PerformanceSection.jsx": 1044,
	"./ApprovalEditorSuite/Performance/PerformanceTable": 1045,
	"./ApprovalEditorSuite/Performance/PerformanceTable.jsx": 1045,
	"./ApprovalEditorSuite/QueueInfo": 1043,
	"./ApprovalEditorSuite/QueueInfo.jsx": 1043,
	"./ApprovalEditorSuite/Snapshot": 1042,
	"./ApprovalEditorSuite/Snapshot.jsx": 1042,
	"./ApprovalEditorSuite/UtilityFunctions": 101,
	"./ApprovalEditorSuite/UtilityFunctions.js": 101,
	"./Article/ArticleModal": 1007,
	"./Article/ArticleModal.jsx": 1007,
	"./ArticleEditors": 1850,
	"./ArticleEditors.js": 1850,
	"./ArticleEditors/AffiliationsModal": 1047,
	"./ArticleEditors/AffiliationsModal.jsx": 1047,
	"./ArticleEditors/ChannelScreeningModal": 1048,
	"./ArticleEditors/ChannelScreeningModal.jsx": 1048,
	"./ArticleEditors/EditorDropdown": 157,
	"./ArticleEditors/EditorDropdown.jsx": 157,
	"./ArticleEditors/Main": 1851,
	"./ArticleEditors/Main.jsx": 1851,
	"./ArticleEditors/StateUpdateModal": 1049,
	"./ArticleEditors/StateUpdateModal.jsx": 1049,
	"./ArticleEditors/Table": 158,
	"./ArticleEditors/Table.jsx": 158,
	"./ArticleIndex": 1520,
	"./ArticleIndex.js": 1520,
	"./ArticleIndex/AdvancedSearch": 371,
	"./ArticleIndex/AdvancedSearch.jsx": 371,
	"./ArticleIndex/AdvancedSearchRow": 372,
	"./ArticleIndex/AdvancedSearchRow.jsx": 372,
	"./ArticleIndex/ArticleTypeModal": 373,
	"./ArticleIndex/ArticleTypeModal.jsx": 373,
	"./ArticleIndex/Categories": 374,
	"./ArticleIndex/Categories.jsx": 374,
	"./ArticleIndex/CategoriesModal": 375,
	"./ArticleIndex/CategoriesModal.jsx": 375,
	"./ArticleIndex/ChannelModal": 376,
	"./ArticleIndex/ChannelModal.jsx": 376,
	"./ArticleIndex/Channels": 377,
	"./ArticleIndex/Channels.jsx": 377,
	"./ArticleIndex/Filters": 378,
	"./ArticleIndex/Filters.jsx": 378,
	"./ArticleIndex/Header": 203,
	"./ArticleIndex/Header.jsx": 203,
	"./ArticleIndex/Main": 1521,
	"./ArticleIndex/Main.jsx": 1521,
	"./ArticleIndex/MostPopular": 1522,
	"./ArticleIndex/MostPopular.jsx": 1522,
	"./ArticleIndex/Search": 86,
	"./ArticleIndex/Search.jsx": 86,
	"./ArticleIndex/Sort": 379,
	"./ArticleIndex/Sort.jsx": 379,
	"./ArticleIndex/Types": 380,
	"./ArticleIndex/Types.jsx": 380,
	"./ArticleRating": 1852,
	"./ArticleRating.js": 1852,
	"./ArticleRating/EmailForm": 1050,
	"./ArticleRating/EmailForm.jsx": 1050,
	"./ArticleRating/Main": 1853,
	"./ArticleRating/Main.jsx": 1853,
	"./ArticleRating/Thanks": 1051,
	"./ArticleRating/Thanks.jsx": 1051,
	"./ArticleShow/AEPreview/Main": 1854,
	"./ArticleShow/AEPreview/Main.jsx": 1854,
	"./ArticleShow/ArticleTab": 1052,
	"./ArticleShow/ArticleTab.jsx": 1052,
	"./ArticleShow/AttachmentsTab": 1064,
	"./ArticleShow/AttachmentsTab.jsx": 1064,
	"./ArticleShow/AuthorsTab": 1054,
	"./ArticleShow/AuthorsTab.jsx": 1054,
	"./ArticleShow/FeatureBar": 1073,
	"./ArticleShow/FeatureBar.jsx": 1073,
	"./ArticleShow/FurtherReading": 1074,
	"./ArticleShow/FurtherReading.jsx": 1074,
	"./ArticleShow/HighlightPop": 1053,
	"./ArticleShow/HighlightPop.jsx": 1053,
	"./ArticleShow/LeftSidebar/Carat": 171,
	"./ArticleShow/LeftSidebar/Carat.jsx": 171,
	"./ArticleShow/LeftSidebar/Categories": 1070,
	"./ArticleShow/LeftSidebar/Categories.jsx": 1070,
	"./ArticleShow/LeftSidebar/CollectionBadge": 1072,
	"./ArticleShow/LeftSidebar/CollectionBadge.jsx": 1072,
	"./ArticleShow/LeftSidebar/Keywords": 1071,
	"./ArticleShow/LeftSidebar/Keywords.jsx": 1071,
	"./ArticleShow/LeftSidebar/Modals/SiqSignInModal": 1069,
	"./ArticleShow/LeftSidebar/Modals/SiqSignInModal.jsx": 1069,
	"./ArticleShow/LeftSidebar/Sidebar": 329,
	"./ArticleShow/LeftSidebar/Sidebar.jsx": 329,
	"./ArticleShow/LeftSidebar/Siq": 330,
	"./ArticleShow/LeftSidebar/Siq.jsx": 330,
	"./ArticleShow/LeftSidebar/TOCLink": 1066,
	"./ArticleShow/LeftSidebar/TOCLink.jsx": 1066,
	"./ArticleShow/LeftSidebar/TableOfContents": 1065,
	"./ArticleShow/LeftSidebar/TableOfContents.jsx": 1065,
	"./ArticleShow/Main": 1855,
	"./ArticleShow/Main.jsx": 1855,
	"./ArticleShow/Metrics/ArticleReads": 1056,
	"./ArticleShow/Metrics/ArticleReads.jsx": 1056,
	"./ArticleShow/Metrics/BarChart": 1059,
	"./ArticleShow/Metrics/BarChart.jsx": 1059,
	"./ArticleShow/Metrics/Citations": 1062,
	"./ArticleShow/Metrics/Citations.jsx": 1062,
	"./ArticleShow/Metrics/IntervalButton": 257,
	"./ArticleShow/Metrics/IntervalButton.jsx": 257,
	"./ArticleShow/Metrics/LineChart": 1058,
	"./ArticleShow/Metrics/LineChart.jsx": 1058,
	"./ArticleShow/Metrics/MapButton": 181,
	"./ArticleShow/Metrics/MapButton.jsx": 181,
	"./ArticleShow/Metrics/MapTable": 327,
	"./ArticleShow/Metrics/MapTable.jsx": 327,
	"./ArticleShow/Metrics/MetricsTab": 1055,
	"./ArticleShow/Metrics/MetricsTab.jsx": 1055,
	"./ArticleShow/Metrics/Plummary": 1063,
	"./ArticleShow/Metrics/Plummary.jsx": 1063,
	"./ArticleShow/Metrics/ReadsCard": 256,
	"./ArticleShow/Metrics/ReadsCard.jsx": 256,
	"./ArticleShow/Metrics/ReadsChart": 1057,
	"./ArticleShow/Metrics/ReadsChart.jsx": 1057,
	"./ArticleShow/Metrics/UsMap": 1061,
	"./ArticleShow/Metrics/UsMap.jsx": 1061,
	"./ArticleShow/Metrics/WorldMap": 1060,
	"./ArticleShow/Metrics/WorldMap.jsx": 1060,
	"./ArticleShow/Modal/CitationModal": 331,
	"./ArticleShow/Modal/CitationModal.jsx": 331,
	"./ArticleShow/MoreAbout/MoreAbout": 1079,
	"./ArticleShow/MoreAbout/MoreAbout.jsx": 1079,
	"./ArticleShow/MoreAbout/Tile": 1080,
	"./ArticleShow/MoreAbout/Tile.jsx": 1080,
	"./ArticleShow/NavBarItem": 258,
	"./ArticleShow/NavBarItem.jsx": 258,
	"./ArticleShow/NavItems": 326,
	"./ArticleShow/NavItems.jsx": 326,
	"./ArticleShow/RightSidebar": 1075,
	"./ArticleShow/RightSidebar.jsx": 1075,
	"./ArticleShow/ShareBar": 1081,
	"./ArticleShow/ShareBar.jsx": 1081,
	"./ArticleShow/Sidebar/ChannelBadge": 1856,
	"./ArticleShow/Sidebar/ChannelBadge.jsx": 1856,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles": 535,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles.jsx": 535,
	"./ArticleShow/Sidebar/MostPopularArticles/Card": 159,
	"./ArticleShow/Sidebar/MostPopularArticles/Card.jsx": 159,
	"./ArticleShow/Sidebar/Promotion": 1076,
	"./ArticleShow/Sidebar/Promotion.jsx": 1076,
	"./ArticleShow/TopSection": 328,
	"./ArticleShow/TopSection.jsx": 328,
	"./AttachmentMixin": 125,
	"./AttachmentMixin.js": 125,
	"./AuthorContributions/Authorship": 1082,
	"./AuthorContributions/Authorship.jsx": 1082,
	"./AuthorContributions/Index": 1857,
	"./AuthorContributions/Index.jsx": 1857,
	"./AuthorContributions/Selector": 1083,
	"./AuthorContributions/Selector.jsx": 1083,
	"./AuthorsHub/GoalModal": 1084,
	"./AuthorsHub/GoalModal.jsx": 1084,
	"./AuthorsHub/GoalOption": 1085,
	"./AuthorsHub/GoalOption.jsx": 1085,
	"./AuthorsHub/GoalSelector": 561,
	"./AuthorsHub/GoalSelector.jsx": 561,
	"./AuthorsHub/Main": 1858,
	"./AuthorsHub/Main.jsx": 1858,
	"./AuthorsHub/SignInModal": 1086,
	"./AuthorsHub/SignInModal.jsx": 1086,
	"./AuthorsHub/Tab": 1088,
	"./AuthorsHub/Tab.jsx": 1088,
	"./AuthorsHub/TabCard": 1089,
	"./AuthorsHub/TabCard.jsx": 1089,
	"./AuthorsHub/TabsSection": 1087,
	"./AuthorsHub/TabsSection.jsx": 1087,
	"./AuthorsHub/UserTestimonial/Testimonial": 1090,
	"./AuthorsHub/UserTestimonial/Testimonial.jsx": 1090,
	"./AuthorsHub/UserTestimonial/UserTestimonial": 1859,
	"./AuthorsHub/UserTestimonial/UserTestimonial.jsx": 1859,
	"./AvatarUploader": 1860,
	"./AvatarUploader.js": 1860,
	"./AvatarUploaderForm/Main": 1523,
	"./AvatarUploaderForm/Main.jsx": 1523,
	"./BannerUploader/Consent": 1091,
	"./BannerUploader/Consent.jsx": 1091,
	"./BannerUploader/EditFile": 1092,
	"./BannerUploader/EditFile.jsx": 1092,
	"./BannerUploader/License": 1093,
	"./BannerUploader/License.jsx": 1093,
	"./BannerUploader/LicenseFile": 1094,
	"./BannerUploader/LicenseFile.jsx": 1094,
	"./BannerUploader/LicenseLink": 1096,
	"./BannerUploader/LicenseLink.jsx": 1096,
	"./BannerUploader/Main": 1861,
	"./BannerUploader/Main.jsx": 1861,
	"./BannerUploader/NewFile": 1097,
	"./BannerUploader/NewFile.jsx": 1097,
	"./BannerUploader/UploadLicenseModal": 1095,
	"./BannerUploader/UploadLicenseModal.jsx": 1095,
	"./Boost": 1862,
	"./Boost.js": 1862,
	"./Boost/BoostModal": 335,
	"./Boost/BoostModal.jsx": 335,
	"./Boost/Card": 91,
	"./Boost/Card.jsx": 91,
	"./Boost/Info": 1524,
	"./Boost/Info.jsx": 1524,
	"./Boost/Main": 1863,
	"./Boost/Main.jsx": 1863,
	"./Boost/Selection": 1099,
	"./Boost/Selection.jsx": 1099,
	"./BrowseIndex/BrowseArticles/ArticleContent": 1106,
	"./BrowseIndex/BrowseArticles/ArticleContent.jsx": 1106,
	"./BrowseIndex/BrowseArticles/BrowseArticles": 1107,
	"./BrowseIndex/BrowseArticles/BrowseArticles.jsx": 1107,
	"./BrowseIndex/BrowseContents/BrowseContents": 1108,
	"./BrowseIndex/BrowseContents/BrowseContents.jsx": 1108,
	"./BrowseIndex/BrowseContents/Content": 1110,
	"./BrowseIndex/BrowseContents/Content.jsx": 1110,
	"./BrowseIndex/BrowseContents/Filters": 1109,
	"./BrowseIndex/BrowseContents/Filters.jsx": 1109,
	"./BrowseIndex/Index": 1864,
	"./BrowseIndex/Index.jsx": 1864,
	"./BrowseIndex/MostPopular": 1865,
	"./BrowseIndex/MostPopular.jsx": 1865,
	"./BrowseIndex/Sidebars/Buttons": 1112,
	"./BrowseIndex/Sidebars/Buttons.jsx": 1112,
	"./BrowseIndex/Sidebars/Categories": 1111,
	"./BrowseIndex/Sidebars/Categories.jsx": 1111,
	"./BrowseIndex/Sidebars/CategorySidebar": 336,
	"./BrowseIndex/Sidebars/CategorySidebar.jsx": 336,
	"./BrowseIndex/Sidebars/RightSideBar": 1113,
	"./BrowseIndex/Sidebars/RightSideBar.jsx": 1113,
	"./CampaignArticles": 1866,
	"./CampaignArticles.js": 1866,
	"./CampaignArticles/AddArticleInput": 563,
	"./CampaignArticles/AddArticleInput.jsx": 563,
	"./CampaignArticles/ArticleListItem": 1114,
	"./CampaignArticles/ArticleListItem.jsx": 1114,
	"./CampaignArticles/CategoryModal": 1115,
	"./CampaignArticles/CategoryModal.jsx": 1115,
	"./CampaignArticles/CategorySelector": 1867,
	"./CampaignArticles/CategorySelector.jsx": 1867,
	"./CampaignArticles/CureusUArticleListItem": 564,
	"./CampaignArticles/CureusUArticleListItem.jsx": 564,
	"./CampaignArticles/CureusUSelector": 1868,
	"./CampaignArticles/CureusUSelector.jsx": 1868,
	"./CampaignArticles/EmailListModal": 1116,
	"./CampaignArticles/EmailListModal.jsx": 1116,
	"./CampaignArticles/EmailListSelector": 1869,
	"./CampaignArticles/EmailListSelector.jsx": 1869,
	"./CampaignArticles/Main": 1870,
	"./CampaignArticles/Main.jsx": 1870,
	"./CampaignArticles/UpdateKlaviyoTemplateButton": 1117,
	"./CampaignArticles/UpdateKlaviyoTemplateButton.jsx": 1117,
	"./CampaignPerformance/DetailedPerformance": 1118,
	"./CampaignPerformance/DetailedPerformance.jsx": 1118,
	"./CampaignPerformance/Main": 1871,
	"./CampaignPerformance/Main.jsx": 1871,
	"./CampaignPerformance/Summary": 1119,
	"./CampaignPerformance/Summary.jsx": 1119,
	"./CampaignSections": 1872,
	"./CampaignSections.js": 1872,
	"./CampaignSections/Main": 1120,
	"./CampaignSections/Main.jsx": 1120,
	"./CampaignSections/SectionListItem": 1121,
	"./CampaignSections/SectionListItem.jsx": 1121,
	"./Campaigns/Main": 1873,
	"./Campaigns/Main.jsx": 1873,
	"./Campaigns/OpenClickChart": 1122,
	"./Campaigns/OpenClickChart.jsx": 1122,
	"./Campaigns/Stats": 1123,
	"./Campaigns/Stats.jsx": 1123,
	"./Campaigns/StatsTable": 565,
	"./Campaigns/StatsTable.jsx": 565,
	"./Categories/Index": 1874,
	"./Categories/Index.jsx": 1874,
	"./ChangeDetectorAlert": 581,
	"./ChangeDetectorAlert.js": 581,
	"./ChannelCampaigns/ChannelCampaignModal": 126,
	"./ChannelCampaigns/ChannelCampaignModal.jsx": 126,
	"./ChannelCampaigns/ChannelOfficialRejectionModal": 1124,
	"./ChannelCampaigns/ChannelOfficialRejectionModal.jsx": 1124,
	"./ChannelCampaigns/ConfirmationModal": 1125,
	"./ChannelCampaigns/ConfirmationModal.jsx": 1125,
	"./ChannelCampaigns/EmailRequestsMain": 1126,
	"./ChannelCampaigns/EmailRequestsMain.jsx": 1126,
	"./ChannelCampaigns/Index": 1875,
	"./ChannelCampaigns/Index.jsx": 1875,
	"./ChannelCampaigns/MemberRequestsMain": 1127,
	"./ChannelCampaigns/MemberRequestsMain.jsx": 1127,
	"./ChannelCampaigns/RequestsIndex": 1876,
	"./ChannelCampaigns/RequestsIndex.jsx": 1876,
	"./ChannelCarousel/Channel": 386,
	"./ChannelCarousel/Channel.jsx": 386,
	"./ChannelCarousel/Main": 1525,
	"./ChannelCarousel/Main.jsx": 1525,
	"./ChannelDesign/About/About": 1128,
	"./ChannelDesign/About/About.jsx": 1128,
	"./ChannelDesign/About/AboutContactModal": 120,
	"./ChannelDesign/About/AboutContactModal.jsx": 120,
	"./ChannelDesign/About/AboutMainSettings": 1129,
	"./ChannelDesign/About/AboutMainSettings.jsx": 1129,
	"./ChannelDesign/About/AboutModal": 119,
	"./ChannelDesign/About/AboutModal.jsx": 119,
	"./ChannelDesign/About/AboutSidebarContent": 1132,
	"./ChannelDesign/About/AboutSidebarContent.jsx": 1132,
	"./ChannelDesign/About/AboutSidebarSettings": 1130,
	"./ChannelDesign/About/AboutSidebarSettings.jsx": 1130,
	"./ChannelDesign/About/AboutWidget": 1131,
	"./ChannelDesign/About/AboutWidget.jsx": 1131,
	"./ChannelDesign/About/ContactModal": 1877,
	"./ChannelDesign/About/ContactModal.jsx": 1877,
	"./ChannelDesign/About/SidebarWidgets/AboutContact": 1133,
	"./ChannelDesign/About/SidebarWidgets/AboutContact.jsx": 1133,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountIcon": 182,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountIcon.jsx": 182,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountsWidget": 1134,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountsWidget.jsx": 1134,
	"./ChannelDesign/About/SocialAccountsModal": 121,
	"./ChannelDesign/About/SocialAccountsModal.jsx": 121,
	"./ChannelDesign/About/SocialModalInput": 58,
	"./ChannelDesign/About/SocialModalInput.jsx": 58,
	"./ChannelDesign/Abstracts": 1135,
	"./ChannelDesign/Abstracts.jsx": 1135,
	"./ChannelDesign/AdminMain": 1878,
	"./ChannelDesign/AdminMain.jsx": 1878,
	"./ChannelDesign/Articles": 1137,
	"./ChannelDesign/Articles.jsx": 1137,
	"./ChannelDesign/DeleteButton": 18,
	"./ChannelDesign/DeleteButton.jsx": 18,
	"./ChannelDesign/Hero": 1141,
	"./ChannelDesign/Hero.jsx": 1141,
	"./ChannelDesign/Home": 282,
	"./ChannelDesign/Home.jsx": 282,
	"./ChannelDesign/HomepageSettings": 225,
	"./ChannelDesign/HomepageSettings.jsx": 225,
	"./ChannelDesign/Internal": 1139,
	"./ChannelDesign/Internal.jsx": 1139,
	"./ChannelDesign/MainContent": 301,
	"./ChannelDesign/MainContent.jsx": 301,
	"./ChannelDesign/MainWidgets/Cards/Abstract50Card": 306,
	"./ChannelDesign/MainWidgets/Cards/Abstract50Card.jsx": 306,
	"./ChannelDesign/MainWidgets/Cards/Article100Card": 1879,
	"./ChannelDesign/MainWidgets/Cards/Article100Card.jsx": 1879,
	"./ChannelDesign/MainWidgets/Cards/Article50Card": 305,
	"./ChannelDesign/MainWidgets/Cards/Article50Card.jsx": 305,
	"./ChannelDesign/MainWidgets/Cards/Channel100Card": 94,
	"./ChannelDesign/MainWidgets/Cards/Channel100Card.jsx": 94,
	"./ChannelDesign/MainWidgets/Cards/Poster50Card": 307,
	"./ChannelDesign/MainWidgets/Cards/Poster50Card.jsx": 307,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberCard": 98,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberCard.jsx": 98,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberRow": 213,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberRow.jsx": 213,
	"./ChannelDesign/MainWidgets/ChannelTeamWidget": 308,
	"./ChannelDesign/MainWidgets/ChannelTeamWidget.jsx": 308,
	"./ChannelDesign/MainWidgets/CustomContentWidget": 304,
	"./ChannelDesign/MainWidgets/CustomContentWidget.jsx": 304,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget": 264,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget.jsx": 264,
	"./ChannelDesign/MainWidgets/InternalContentWidget": 303,
	"./ChannelDesign/MainWidgets/InternalContentWidget.jsx": 303,
	"./ChannelDesign/MainWidgets/RecentlyPublishedWidget": 302,
	"./ChannelDesign/MainWidgets/RecentlyPublishedWidget.jsx": 302,
	"./ChannelDesign/Meetings": 1140,
	"./ChannelDesign/Meetings.jsx": 1140,
	"./ChannelDesign/MobileNavBar": 1880,
	"./ChannelDesign/MobileNavBar.jsx": 1880,
	"./ChannelDesign/Modals/ChannelTeam": 111,
	"./ChannelDesign/Modals/ChannelTeam.jsx": 111,
	"./ChannelDesign/Modals/ChannelTeamMember": 240,
	"./ChannelDesign/Modals/ChannelTeamMember.jsx": 240,
	"./ChannelDesign/Modals/ChannelTeamSidebar": 112,
	"./ChannelDesign/Modals/ChannelTeamSidebar.jsx": 112,
	"./ChannelDesign/Modals/CureusPromotionModal": 114,
	"./ChannelDesign/Modals/CureusPromotionModal.jsx": 114,
	"./ChannelDesign/Modals/CustomContentModal": 110,
	"./ChannelDesign/Modals/CustomContentModal.jsx": 110,
	"./ChannelDesign/Modals/FeaturedMultimediaModal": 263,
	"./ChannelDesign/Modals/FeaturedMultimediaModal.jsx": 263,
	"./ChannelDesign/Modals/HeroEditModal": 1142,
	"./ChannelDesign/Modals/HeroEditModal.jsx": 1142,
	"./ChannelDesign/Modals/InputElements/CustomContentModalInputButtons": 102,
	"./ChannelDesign/Modals/InputElements/CustomContentModalInputButtons.jsx": 102,
	"./ChannelDesign/Modals/InputElements/PollOption": 241,
	"./ChannelDesign/Modals/InputElements/PollOption.jsx": 241,
	"./ChannelDesign/Modals/InputElements/RadioInput": 238,
	"./ChannelDesign/Modals/InputElements/RadioInput.jsx": 238,
	"./ChannelDesign/Modals/InputElements/SizeInput": 156,
	"./ChannelDesign/Modals/InputElements/SizeInput.jsx": 156,
	"./ChannelDesign/Modals/InputElements/TextField": 239,
	"./ChannelDesign/Modals/InputElements/TextField.jsx": 239,
	"./ChannelDesign/Modals/InternalContent": 80,
	"./ChannelDesign/Modals/InternalContent.jsx": 80,
	"./ChannelDesign/Modals/MostPopularContentModal": 118,
	"./ChannelDesign/Modals/MostPopularContentModal.jsx": 118,
	"./ChannelDesign/Modals/OverviewSidebarModal": 115,
	"./ChannelDesign/Modals/OverviewSidebarModal.jsx": 115,
	"./ChannelDesign/Modals/Poll": 117,
	"./ChannelDesign/Modals/Poll.jsx": 117,
	"./ChannelDesign/Modals/Promotion": 113,
	"./ChannelDesign/Modals/Promotion.jsx": 113,
	"./ChannelDesign/Modals/RecentlyPublished": 299,
	"./ChannelDesign/Modals/RecentlyPublished.jsx": 299,
	"./ChannelDesign/Modals/TwitterSidebarModal": 116,
	"./ChannelDesign/Modals/TwitterSidebarModal.jsx": 116,
	"./ChannelDesign/NavItems": 1136,
	"./ChannelDesign/NavItems.jsx": 1136,
	"./ChannelDesign/NoArticlesDisplay": 309,
	"./ChannelDesign/NoArticlesDisplay.jsx": 309,
	"./ChannelDesign/Posters": 1138,
	"./ChannelDesign/Posters.jsx": 1138,
	"./ChannelDesign/SettingsButton": 32,
	"./ChannelDesign/SettingsButton.jsx": 32,
	"./ChannelDesign/SidebarContent": 310,
	"./ChannelDesign/SidebarContent.jsx": 310,
	"./ChannelDesign/SidebarSettings": 300,
	"./ChannelDesign/SidebarSettings.jsx": 300,
	"./ChannelDesign/SidebarWidgets/CureusPromotion": 313,
	"./ChannelDesign/SidebarWidgets/CureusPromotion.jsx": 313,
	"./ChannelDesign/SidebarWidgets/MostPopularContent": 317,
	"./ChannelDesign/SidebarWidgets/MostPopularContent.jsx": 317,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewInfoRow": 137,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewInfoRow.jsx": 137,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewModalInput": 103,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewModalInput.jsx": 103,
	"./ChannelDesign/SidebarWidgets/OverviewWidget": 314,
	"./ChannelDesign/SidebarWidgets/OverviewWidget.jsx": 314,
	"./ChannelDesign/SidebarWidgets/Poll/PollOption": 316,
	"./ChannelDesign/SidebarWidgets/Poll/PollOption.jsx": 316,
	"./ChannelDesign/SidebarWidgets/Poll/PollWidget": 315,
	"./ChannelDesign/SidebarWidgets/Poll/PollWidget.jsx": 315,
	"./ChannelDesign/SidebarWidgets/PromotionWidget": 312,
	"./ChannelDesign/SidebarWidgets/PromotionWidget.jsx": 312,
	"./ChannelDesign/SidebarWidgets/TeamMemberSidebar": 311,
	"./ChannelDesign/SidebarWidgets/TeamMemberSidebar.jsx": 311,
	"./ChannelDesign/SidebarWidgets/TwitterWidget": 926,
	"./ChannelDesign/SidebarWidgets/TwitterWidget.jsx": 926,
	"./ChannelDesign/UpdateButton": 23,
	"./ChannelDesign/UpdateButton.jsx": 23,
	"./ChannelDesignWidget": 1881,
	"./ChannelDesignWidget.js": 1881,
	"./ChannelDesignWidget/ChannelTeamMember": 1143,
	"./ChannelDesignWidget/ChannelTeamMember.jsx": 1143,
	"./ChannelDesignWidget/Main": 1882,
	"./ChannelDesignWidget/Main.jsx": 1882,
	"./ChannelDesignWidget/NewSidebarWidget": 1146,
	"./ChannelDesignWidget/NewSidebarWidget.jsx": 1146,
	"./ChannelDesignWidget/Promotion": 566,
	"./ChannelDesignWidget/Promotion.jsx": 566,
	"./ChannelDesignWidget/Twitter": 1145,
	"./ChannelDesignWidget/Twitter.jsx": 1145,
	"./ChannelDesignWidget/Widget": 1144,
	"./ChannelDesignWidget/Widget.jsx": 1144,
	"./Channels/AbstractStates/Abandoned": 1147,
	"./Channels/AbstractStates/Abandoned.jsx": 1147,
	"./Channels/AbstractStates/All": 1148,
	"./Channels/AbstractStates/All.jsx": 1148,
	"./Channels/AbstractStates/ChannelEditorApproval": 1149,
	"./Channels/AbstractStates/ChannelEditorApproval.jsx": 1149,
	"./Channels/AbstractStates/ChannelEditorApprovalDeferred": 1150,
	"./Channels/AbstractStates/ChannelEditorApprovalDeferred.jsx": 1150,
	"./Channels/AbstractStates/DeskRejected": 1151,
	"./Channels/AbstractStates/DeskRejected.jsx": 1151,
	"./Channels/AbstractStates/Draft": 1152,
	"./Channels/AbstractStates/Draft.jsx": 1152,
	"./Channels/AbstractStates/Published": 1153,
	"./Channels/AbstractStates/Published.jsx": 1153,
	"./Channels/Abstracts": 1154,
	"./Channels/Abstracts.jsx": 1154,
	"./Channels/AddPersonModal": 975,
	"./Channels/AddPersonModal.jsx": 975,
	"./Channels/ArticleStates/Abandoned": 1155,
	"./Channels/ArticleStates/Abandoned.jsx": 1155,
	"./Channels/ArticleStates/All": 1156,
	"./Channels/ArticleStates/All.jsx": 1156,
	"./Channels/ArticleStates/Approved": 1157,
	"./Channels/ArticleStates/Approved.jsx": 1157,
	"./Channels/ArticleStates/Blocked": 1158,
	"./Channels/ArticleStates/Blocked.jsx": 1158,
	"./Channels/ArticleStates/ChannelEditorApproval": 1159,
	"./Channels/ArticleStates/ChannelEditorApproval.jsx": 1159,
	"./Channels/ArticleStates/ChannelEditorApprovalDeferred": 1160,
	"./Channels/ArticleStates/ChannelEditorApprovalDeferred.jsx": 1160,
	"./Channels/ArticleStates/ChannelEditorApprovalMyWork": 1161,
	"./Channels/ArticleStates/ChannelEditorApprovalMyWork.jsx": 1161,
	"./Channels/ArticleStates/CureusEditorApproval": 1162,
	"./Channels/ArticleStates/CureusEditorApproval.jsx": 1162,
	"./Channels/ArticleStates/CureusEditorApprovalDeferred": 1163,
	"./Channels/ArticleStates/CureusEditorApprovalDeferred.jsx": 1163,
	"./Channels/ArticleStates/DeskRejected": 1164,
	"./Channels/ArticleStates/DeskRejected.jsx": 1164,
	"./Channels/ArticleStates/Draft": 1165,
	"./Channels/ArticleStates/Draft.jsx": 1165,
	"./Channels/ArticleStates/EditorCheck": 1166,
	"./Channels/ArticleStates/EditorCheck.jsx": 1166,
	"./Channels/ArticleStates/EditorCheckDeferred": 1167,
	"./Channels/ArticleStates/EditorCheckDeferred.jsx": 1167,
	"./Channels/ArticleStates/EditorPreview": 1168,
	"./Channels/ArticleStates/EditorPreview.jsx": 1168,
	"./Channels/ArticleStates/EditorPreviewDeferred": 1169,
	"./Channels/ArticleStates/EditorPreviewDeferred.jsx": 1169,
	"./Channels/ArticleStates/EditorPreviewMyWork": 1170,
	"./Channels/ArticleStates/EditorPreviewMyWork.jsx": 1170,
	"./Channels/ArticleStates/EditorScreening": 1171,
	"./Channels/ArticleStates/EditorScreening.jsx": 1171,
	"./Channels/ArticleStates/EditorScreeningMyWork": 1172,
	"./Channels/ArticleStates/EditorScreeningMyWork.jsx": 1172,
	"./Channels/ArticleStates/InRereview": 1173,
	"./Channels/ArticleStates/InRereview.jsx": 1173,
	"./Channels/ArticleStates/InReview": 1174,
	"./Channels/ArticleStates/InReview.jsx": 1174,
	"./Channels/ArticleStates/Published": 1175,
	"./Channels/ArticleStates/Published.jsx": 1175,
	"./Channels/ArticleStates/RejectedChannelScreening": 1176,
	"./Channels/ArticleStates/RejectedChannelScreening.jsx": 1176,
	"./Channels/ArticleStates/ReviewsComplete": 1177,
	"./Channels/ArticleStates/ReviewsComplete.jsx": 1177,
	"./Channels/Articles": 1178,
	"./Channels/Articles.jsx": 1178,
	"./Channels/Dashboard": 1179,
	"./Channels/Dashboard.jsx": 1179,
	"./Channels/Main": 1883,
	"./Channels/Main.jsx": 1883,
	"./Channels/MyWorksMain": 1884,
	"./Channels/MyWorksMain.jsx": 1884,
	"./Channels/PeerReviewers": 319,
	"./Channels/PeerReviewers.jsx": 319,
	"./Channels/PeerReviewersMain": 1885,
	"./Channels/PeerReviewersMain.jsx": 1885,
	"./Channels/PosterStates/Abandoned": 1191,
	"./Channels/PosterStates/Abandoned.jsx": 1191,
	"./Channels/PosterStates/All": 1192,
	"./Channels/PosterStates/All.jsx": 1192,
	"./Channels/PosterStates/ChannelEditorApproval": 1188,
	"./Channels/PosterStates/ChannelEditorApproval.jsx": 1188,
	"./Channels/PosterStates/ChannelEditorApprovalDeferred": 1187,
	"./Channels/PosterStates/ChannelEditorApprovalDeferred.jsx": 1187,
	"./Channels/PosterStates/DeskRejected": 1190,
	"./Channels/PosterStates/DeskRejected.jsx": 1190,
	"./Channels/PosterStates/Draft": 1186,
	"./Channels/PosterStates/Draft.jsx": 1186,
	"./Channels/PosterStates/Published": 1189,
	"./Channels/PosterStates/Published.jsx": 1189,
	"./Channels/Posters": 1185,
	"./Channels/Posters.jsx": 1185,
	"./Channels/ReviewerTableMain": 1193,
	"./Channels/ReviewerTableMain.jsx": 1193,
	"./Channels/ReviewerTableStates/Invited": 1194,
	"./Channels/ReviewerTableStates/Invited.jsx": 1194,
	"./Channels/ReviewerTableStates/Reviewing": 1195,
	"./Channels/ReviewerTableStates/Reviewing.jsx": 1195,
	"./Channels/UploadPeerReviewers": 974,
	"./Channels/UploadPeerReviewers.jsx": 974,
	"./CkEditor/LatexInfoModal": 1196,
	"./CkEditor/LatexInfoModal.jsx": 1196,
	"./CkEditor/ModalTrigger": 1886,
	"./CkEditor/ModalTrigger.jsx": 1886,
	"./CollectionArticles/CollectionArticleCard": 339,
	"./CollectionArticles/CollectionArticleCard.jsx": 339,
	"./CollectionArticles/KeywordSearchedArticles": 1197,
	"./CollectionArticles/KeywordSearchedArticles.jsx": 1197,
	"./CollectionArticles/Main": 1887,
	"./CollectionArticles/Main.jsx": 1887,
	"./CollectionFaqs/FaqItem": 1198,
	"./CollectionFaqs/FaqItem.jsx": 1198,
	"./CollectionFaqs/Index": 1888,
	"./CollectionFaqs/Index.jsx": 1888,
	"./CollectionFaqs/NewFaq": 1199,
	"./CollectionFaqs/NewFaq.jsx": 1199,
	"./CollectionShow/Articles/Articles": 1200,
	"./CollectionShow/Articles/Articles.jsx": 1200,
	"./CollectionShow/Articles/MultimediaCard": 1201,
	"./CollectionShow/Articles/MultimediaCard.jsx": 1201,
	"./CollectionShow/Authors/AuthorCard": 1202,
	"./CollectionShow/Authors/AuthorCard.jsx": 1202,
	"./CollectionShow/Authors/Authors": 1203,
	"./CollectionShow/Authors/Authors.jsx": 1203,
	"./CollectionShow/Hero": 1204,
	"./CollectionShow/Hero.jsx": 1204,
	"./CollectionShow/Index": 1889,
	"./CollectionShow/Index.jsx": 1889,
	"./CollectionShow/Overview/ArticleCard": 1210,
	"./CollectionShow/Overview/ArticleCard.jsx": 1210,
	"./CollectionShow/Overview/CollectionComments": 1211,
	"./CollectionShow/Overview/CollectionComments.jsx": 1211,
	"./CollectionShow/Overview/GuestEditor": 1213,
	"./CollectionShow/Overview/GuestEditor.jsx": 1213,
	"./CollectionShow/Overview/Overview": 1206,
	"./CollectionShow/Overview/Overview.jsx": 1206,
	"./CollectionShow/Overview/Question": 1208,
	"./CollectionShow/Overview/Question.jsx": 1208,
	"./CollectionShow/Overview/Questions": 1207,
	"./CollectionShow/Overview/Questions.jsx": 1207,
	"./CollectionShow/Overview/RecentArticles": 1209,
	"./CollectionShow/Overview/RecentArticles.jsx": 1209,
	"./CollectionShow/Overview/TopAuthor": 1212,
	"./CollectionShow/Overview/TopAuthor.jsx": 1212,
	"./CollectionShow/Tab": 1205,
	"./CollectionShow/Tab.jsx": 1205,
	"./Collections/ApplicationForm": 1890,
	"./Collections/ApplicationForm.jsx": 1890,
	"./Collections/BigCard": 1214,
	"./Collections/BigCard.jsx": 1214,
	"./Collections/ErrorMessage": 568,
	"./Collections/ErrorMessage.jsx": 568,
	"./Collections/Filters": 1215,
	"./Collections/Filters.jsx": 1215,
	"./Collections/Label": 53,
	"./Collections/Label.jsx": 53,
	"./Collections/Main": 1891,
	"./Collections/Main.jsx": 1891,
	"./Collections/SmallCard": 1216,
	"./Collections/SmallCard.jsx": 1216,
	"./CommentForm": 1892,
	"./CommentForm.js": 1892,
	"./CommentForm/Comment": 560,
	"./CommentForm/Comment.jsx": 560,
	"./CommentForm/CommentForm": 333,
	"./CommentForm/CommentForm.jsx": 333,
	"./CommentForm/FlagModal": 1077,
	"./CommentForm/FlagModal.jsx": 1077,
	"./CommentForm/Main": 332,
	"./CommentForm/Main.jsx": 332,
	"./CommentForm/SplitDropDownSort": 1078,
	"./CommentForm/SplitDropDownSort.jsx": 1078,
	"./ConfirmationModal": 66,
	"./ConfirmationModal.jsx": 66,
	"./ContactCoAuthors": 325,
	"./ContactCoAuthors.jsx": 325,
	"./ContactCoAuthorsModal": 1034,
	"./ContactCoAuthorsModal.jsx": 1034,
	"./ContentPerformance/DetailedPerformance": 1217,
	"./ContentPerformance/DetailedPerformance.jsx": 1217,
	"./ContentPerformance/Main": 1893,
	"./ContentPerformance/Main.jsx": 1893,
	"./ContentPerformance/Summary": 1218,
	"./ContentPerformance/Summary.jsx": 1218,
	"./ContentPost/SocialMedia/Main": 1894,
	"./ContentPost/SocialMedia/Main.jsx": 1894,
	"./ContentPost/SocialMedia/Table": 1219,
	"./ContentPost/SocialMedia/Table.jsx": 1219,
	"./CureusEditingServices": 1527,
	"./CureusEditingServices.js": 1527,
	"./CureusEditingServices/Button": 615,
	"./CureusEditingServices/Button.jsx": 615,
	"./CureusEditingServices/Calculator": 1528,
	"./CureusEditingServices/Calculator.jsx": 1528,
	"./CureusEditingServices/DropDown": 88,
	"./CureusEditingServices/DropDown.jsx": 88,
	"./Dashboard": 1895,
	"./Dashboard.js": 1895,
	"./Dashboard/ActionButton/AbandonModal": 340,
	"./Dashboard/ActionButton/AbandonModal.jsx": 340,
	"./Dashboard/ActionButton/Approved": 1220,
	"./Dashboard/ActionButton/Approved.jsx": 1220,
	"./Dashboard/ActionButton/Draft": 1223,
	"./Dashboard/ActionButton/Draft.jsx": 1223,
	"./Dashboard/ActionButton/InReview": 1224,
	"./Dashboard/ActionButton/InReview.jsx": 1224,
	"./Dashboard/ActionButton/PaidServiceModal": 176,
	"./Dashboard/ActionButton/PaidServiceModal.jsx": 176,
	"./Dashboard/ActionButton/PostDeferralOptionsModal": 1529,
	"./Dashboard/ActionButton/PostDeferralOptionsModal.jsx": 1529,
	"./Dashboard/ActionButton/RereviewsComplete": 1225,
	"./Dashboard/ActionButton/RereviewsComplete.jsx": 1225,
	"./Dashboard/ActionButton/ReviewsComplete": 1226,
	"./Dashboard/ActionButton/ReviewsComplete.jsx": 1226,
	"./Dashboard/ArticleDetails": 1896,
	"./Dashboard/ArticleDetails.jsx": 1896,
	"./Dashboard/ArticleStateDetails": 1227,
	"./Dashboard/ArticleStateDetails.jsx": 1227,
	"./Dashboard/CoauthorTool/CoauthorMain": 342,
	"./Dashboard/CoauthorTool/CoauthorMain.jsx": 342,
	"./Dashboard/CoauthorTool/Row": 1229,
	"./Dashboard/CoauthorTool/Row.jsx": 1229,
	"./Dashboard/EmailEditingServiceReceiptModal": 343,
	"./Dashboard/EmailEditingServiceReceiptModal.jsx": 343,
	"./Dashboard/Metrics/Main": 1897,
	"./Dashboard/Metrics/Main.jsx": 1897,
	"./Dashboard/ReviewsDashboard/ArticleNotifications": 1230,
	"./Dashboard/ReviewsDashboard/ArticleNotifications.jsx": 1230,
	"./Dashboard/ReviewsDashboard/CoauthorNotification": 1231,
	"./Dashboard/ReviewsDashboard/CoauthorNotification.jsx": 1231,
	"./Dashboard/ReviewsDashboard/Invite": 236,
	"./Dashboard/ReviewsDashboard/Invite.jsx": 236,
	"./Dashboard/ReviewsDashboard/Main": 1232,
	"./Dashboard/ReviewsDashboard/Main.jsx": 1232,
	"./Dashboard/ReviewsDashboard/NewModal": 344,
	"./Dashboard/ReviewsDashboard/NewModal.jsx": 344,
	"./Dashboard/ReviewsDashboard/OwnershipRating": 1222,
	"./Dashboard/ReviewsDashboard/OwnershipRating.jsx": 1222,
	"./Dashboard/ReviewsDashboard/PeerReviewProgress": 347,
	"./Dashboard/ReviewsDashboard/PeerReviewProgress.jsx": 347,
	"./Dashboard/ReviewsDashboard/RatingModal": 341,
	"./Dashboard/ReviewsDashboard/RatingModal.jsx": 341,
	"./Dashboard/ReviewsDashboard/RemindModal": 346,
	"./Dashboard/ReviewsDashboard/RemindModal.jsx": 346,
	"./Dashboard/ReviewsDashboard/RemindSpecificModal": 345,
	"./Dashboard/ReviewsDashboard/RemindSpecificModal.jsx": 345,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/LearnMoreModal": 543,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/LearnMoreModal.jsx": 543,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/QuickviewModal": 1234,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/QuickviewModal.jsx": 1234,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/ReviewerActivityMain": 348,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/ReviewerActivityMain.jsx": 348,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/Row": 1233,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/Row.jsx": 1233,
	"./Dashboard/ReviewsDashboard/ReviewerRating": 1221,
	"./Dashboard/ReviewsDashboard/ReviewerRating.jsx": 1221,
	"./Dashboard/ReviewsDashboard/SuperMain": 1898,
	"./Dashboard/ReviewsDashboard/SuperMain.jsx": 1898,
	"./Dashboard/StateHistoryModal": 127,
	"./Dashboard/StateHistoryModal.jsx": 127,
	"./Dashboard/StateHistoryRow": 1228,
	"./Dashboard/StateHistoryRow.jsx": 1228,
	"./DeferralReasons": 1899,
	"./DeferralReasons.js": 1899,
	"./DeferralReasons/DeferralModal": 1235,
	"./DeferralReasons/DeferralModal.jsx": 1235,
	"./DeferralReasons/Main": 1900,
	"./DeferralReasons/Main.jsx": 1900,
	"./DeferralReasons/MainModal": 1236,
	"./DeferralReasons/MainModal.jsx": 1236,
	"./DeferralReasons/PreferredChoiceModal": 1237,
	"./DeferralReasons/PreferredChoiceModal.jsx": 1237,
	"./DeskRejectedModal": 1238,
	"./DeskRejectedModal.jsx": 1238,
	"./DiscountWidget/Main": 1901,
	"./DiscountWidget/Main.jsx": 1901,
	"./Discussions/AddModal": 293,
	"./Discussions/AddModal.jsx": 293,
	"./Discussions/DiscussionCard": 292,
	"./Discussions/DiscussionCard.jsx": 292,
	"./Discussions/HomepageContainer": 936,
	"./Discussions/HomepageContainer.jsx": 936,
	"./Discussions/Index": 291,
	"./Discussions/Index.jsx": 291,
	"./DiversityTool": 1902,
	"./DiversityTool.js": 1902,
	"./DiversityTool/Author": 211,
	"./DiversityTool/Author.jsx": 211,
	"./DiversityTool/Main": 294,
	"./DiversityTool/Main.jsx": 294,
	"./DiversityTool/Reviewer": 212,
	"./DiversityTool/Reviewer.jsx": 212,
	"./DropdownNav": 1903,
	"./DropdownNav.jsx": 1903,
	"./EditorActivity/ApprovalCompleted": 1239,
	"./EditorActivity/ApprovalCompleted.jsx": 1239,
	"./EditorActivity/ApprovalMatches": 1240,
	"./EditorActivity/ApprovalMatches.jsx": 1240,
	"./EditorActivity/ApprovalRating": 1241,
	"./EditorActivity/ApprovalRating.jsx": 1241,
	"./EditorActivity/AverageScores": 1242,
	"./EditorActivity/AverageScores.jsx": 1242,
	"./EditorActivity/CompletedRow": 31,
	"./EditorActivity/CompletedRow.jsx": 31,
	"./EditorActivity/CopyCompleted": 1243,
	"./EditorActivity/CopyCompleted.jsx": 1243,
	"./EditorActivity/DualCompleted": 1244,
	"./EditorActivity/DualCompleted.jsx": 1244,
	"./EditorActivity/Main": 1904,
	"./EditorActivity/Main.jsx": 1904,
	"./EditorActivity/MessagesCommentsToAuthor": 569,
	"./EditorActivity/MessagesCommentsToAuthor.jsx": 569,
	"./EditorActivity/RejectedReviews": 1246,
	"./EditorActivity/RejectedReviews.jsx": 1246,
	"./EditorActivity/SubmissionsCompleted": 1245,
	"./EditorActivity/SubmissionsCompleted.jsx": 1245,
	"./EditorArticleRating": 1905,
	"./EditorArticleRating.js": 1905,
	"./EditorArticleRating/BlockOrDesk": 570,
	"./EditorArticleRating/BlockOrDesk.jsx": 570,
	"./EditorArticleRating/CheckListBlock": 1248,
	"./EditorArticleRating/CheckListBlock.jsx": 1248,
	"./EditorArticleRating/CheckListDesk": 1247,
	"./EditorArticleRating/CheckListDesk.jsx": 1247,
	"./EditorArticleRating/ChecklistItem": 39,
	"./EditorArticleRating/ChecklistItem.jsx": 39,
	"./EditorArticleRating/Deferral": 1249,
	"./EditorArticleRating/Deferral.jsx": 1249,
	"./EditorArticleRating/EarModal": 1250,
	"./EditorArticleRating/EarModal.jsx": 1250,
	"./EditorArticleRating/Email": 1251,
	"./EditorArticleRating/Email.jsx": 1251,
	"./EditorArticleRating/Main": 1906,
	"./EditorArticleRating/Main.jsx": 1906,
	"./EditorArticleRating/OAChecklistItem": 76,
	"./EditorArticleRating/OAChecklistItem.jsx": 76,
	"./EditorArticleRating/OriginalArticleStep": 1252,
	"./EditorArticleRating/OriginalArticleStep.jsx": 1252,
	"./EditorArticleRating/Slider": 131,
	"./EditorArticleRating/Slider.jsx": 131,
	"./EditorGoals/DualRow": 1253,
	"./EditorGoals/DualRow.jsx": 1253,
	"./EditorGoals/Row": 1254,
	"./EditorGoals/Row.jsx": 1254,
	"./EditorGoals/Table": 1907,
	"./EditorGoals/Table.jsx": 1907,
	"./EditorialBoard": 1530,
	"./EditorialBoard.js": 1530,
	"./EditorialBoard/Editor": 387,
	"./EditorialBoard/Editor.jsx": 387,
	"./EditorialBoard/Main": 1531,
	"./EditorialBoard/Main.jsx": 1531,
	"./EditorialBoard/Sidebar": 252,
	"./EditorialBoard/Sidebar.jsx": 252,
	"./EditorialSettings/CopyPeRatio": 1908,
	"./EditorialSettings/CopyPeRatio.jsx": 1908,
	"./Editors/EditorAnnouncement": 1909,
	"./Editors/EditorAnnouncement.jsx": 1909,
	"./Editors/EditorMessagesDashboard/ClosedTable": 1255,
	"./Editors/EditorMessagesDashboard/ClosedTable.jsx": 1255,
	"./Editors/EditorMessagesDashboard/EditorMessagesTable": 349,
	"./Editors/EditorMessagesDashboard/EditorMessagesTable.jsx": 349,
	"./Editors/EditorMessagesDashboard/Main": 1910,
	"./Editors/EditorMessagesDashboard/Main.jsx": 1910,
	"./Editors/EditorMessagesDashboard/MessageStatusModal": 1256,
	"./Editors/EditorMessagesDashboard/MessageStatusModal.jsx": 1256,
	"./Editors/EditorMessagesDashboard/OpenTable": 1257,
	"./Editors/EditorMessagesDashboard/OpenTable.jsx": 1257,
	"./EmailCampaignIndex": 1911,
	"./EmailCampaignIndex.js": 1911,
	"./EmailCampaignIndex/ActionSplitButtons": 1258,
	"./EmailCampaignIndex/ActionSplitButtons.jsx": 1258,
	"./EmailCampaignIndex/CampaignRow": 1259,
	"./EmailCampaignIndex/CampaignRow.jsx": 1259,
	"./EmailCampaignIndex/CreateCampaignModal": 1261,
	"./EmailCampaignIndex/CreateCampaignModal.jsx": 1261,
	"./EmailCampaignIndex/DeleteButton": 1262,
	"./EmailCampaignIndex/DeleteButton.jsx": 1262,
	"./EmailCampaignIndex/DeleteCampaignsModal": 1263,
	"./EmailCampaignIndex/DeleteCampaignsModal.jsx": 1263,
	"./EmailCampaignIndex/Filter": 1264,
	"./EmailCampaignIndex/Filter.jsx": 1264,
	"./EmailCampaignIndex/Main": 1912,
	"./EmailCampaignIndex/Main.jsx": 1912,
	"./EmailCampaignIndex/RenameCampaignModal": 1260,
	"./EmailCampaignIndex/RenameCampaignModal.jsx": 1260,
	"./EmailCampaignIndex/TemplateFilter": 175,
	"./EmailCampaignIndex/TemplateFilter.jsx": 175,
	"./EmailCampaignIndex/UpdateStatsButton": 1265,
	"./EmailCampaignIndex/UpdateStatsButton.jsx": 1265,
	"./EmailListIndex": 1913,
	"./EmailListIndex.js": 1913,
	"./EmailListIndex/BulkActions": 1266,
	"./EmailListIndex/BulkActions.jsx": 1266,
	"./EmailListIndex/BulkAddModal": 571,
	"./EmailListIndex/BulkAddModal.jsx": 571,
	"./EmailListIndex/BulkDeleteModal": 1268,
	"./EmailListIndex/BulkDeleteModal.jsx": 1268,
	"./EmailListIndex/BulkExportModal": 1269,
	"./EmailListIndex/BulkExportModal.jsx": 1269,
	"./EmailListIndex/ChannelMain": 1914,
	"./EmailListIndex/ChannelMain.jsx": 1914,
	"./EmailListIndex/CheckboxToggler": 1270,
	"./EmailListIndex/CheckboxToggler.jsx": 1270,
	"./EmailListIndex/CreateList": 350,
	"./EmailListIndex/CreateList.jsx": 350,
	"./EmailListIndex/CreateListModal": 351,
	"./EmailListIndex/CreateListModal.jsx": 351,
	"./EmailListIndex/ExportCsvModal": 1271,
	"./EmailListIndex/ExportCsvModal.jsx": 1271,
	"./EmailListIndex/LockedListSelectedModal": 1267,
	"./EmailListIndex/LockedListSelectedModal.jsx": 1267,
	"./EmailListIndex/Main": 1915,
	"./EmailListIndex/Main.jsx": 1915,
	"./EmailListIndex/Row": 1275,
	"./EmailListIndex/Row.jsx": 1275,
	"./EmailListIndex/Search": 1273,
	"./EmailListIndex/Search.jsx": 1273,
	"./EmailListIndex/Sorter": 1272,
	"./EmailListIndex/Sorter.jsx": 1272,
	"./EmailListIndex/Table": 1274,
	"./EmailListIndex/Table.jsx": 1274,
	"./EmailTool": 90,
	"./EmailTool.js": 90,
	"./EmailTool/AddDropdown": 1279,
	"./EmailTool/AddDropdown.jsx": 1279,
	"./EmailTool/AddFromCureus": 1280,
	"./EmailTool/AddFromCureus.jsx": 1280,
	"./EmailTool/AddFromCureusMain": 1916,
	"./EmailTool/AddFromCureusMain.jsx": 1916,
	"./EmailTool/AddFromExisting": 1917,
	"./EmailTool/AddFromExisting.jsx": 1917,
	"./EmailTool/AddFromExistingModal": 1289,
	"./EmailTool/AddFromExistingModal.jsx": 1289,
	"./EmailTool/AddFromPmcModal": 1290,
	"./EmailTool/AddFromPmcModal.jsx": 1290,
	"./EmailTool/AddPersonModal": 1291,
	"./EmailTool/AddPersonModal.jsx": 1291,
	"./EmailTool/AddToList": 1281,
	"./EmailTool/AddToList.jsx": 1281,
	"./EmailTool/AddToRefresh": 1282,
	"./EmailTool/AddToRefresh.jsx": 1282,
	"./EmailTool/AllInviteesTable": 1292,
	"./EmailTool/AllInviteesTable.jsx": 1292,
	"./EmailTool/DeleteListEmailsModal": 1293,
	"./EmailTool/DeleteListEmailsModal.jsx": 1293,
	"./EmailTool/EmailListRefreshes": 1294,
	"./EmailTool/EmailListRefreshes.jsx": 1294,
	"./EmailTool/EmailListTable": 1295,
	"./EmailTool/EmailListTable.jsx": 1295,
	"./EmailTool/Filter": 1284,
	"./EmailTool/Filter.jsx": 1284,
	"./EmailTool/FilterControl": 1288,
	"./EmailTool/FilterControl.jsx": 1288,
	"./EmailTool/FilterNotification": 1285,
	"./EmailTool/FilterNotification.jsx": 1285,
	"./EmailTool/FilterTool": 1283,
	"./EmailTool/FilterTool.jsx": 1283,
	"./EmailTool/FilterableTable": 1286,
	"./EmailTool/FilterableTable.jsx": 1286,
	"./EmailTool/LengthControl": 1287,
	"./EmailTool/LengthControl.jsx": 1287,
	"./EmailTool/LockedTable": 1296,
	"./EmailTool/LockedTable.jsx": 1296,
	"./EmailTool/Search": 177,
	"./EmailTool/Search.jsx": 177,
	"./EmailTool/SubscribedFilter": 178,
	"./EmailTool/SubscribedFilter.jsx": 178,
	"./EmailTool/SwitchList": 1918,
	"./EmailTool/SwitchList.jsx": 1918,
	"./EmailTool/Table": 128,
	"./EmailTool/Table.jsx": 128,
	"./EmailTool/UploadFileModal": 352,
	"./EmailTool/UploadFileModal.jsx": 352,
	"./EmailTool/UploadUsers": 1919,
	"./EmailTool/UploadUsers.jsx": 1919,
	"./EmailTool/ViewAllChannelInvitees": 1920,
	"./EmailTool/ViewAllChannelInvitees.jsx": 1920,
	"./EmailTool/ViewChannelList": 1921,
	"./EmailTool/ViewChannelList.jsx": 1921,
	"./EmailTool/ViewList": 1922,
	"./EmailTool/ViewList.jsx": 1922,
	"./EmailTool/ViewableTable": 1297,
	"./EmailTool/ViewableTable.jsx": 1297,
	"./EmailTool/buttons": 937,
	"./EmailTool/buttons.js": 937,
	"./EmailTool/fluxxor/actions": 1278,
	"./EmailTool/fluxxor/actions.js": 1278,
	"./EmailTool/fluxxor/constants": 33,
	"./EmailTool/fluxxor/constants.js": 33,
	"./EmailTool/fluxxor/stores/FilterTool": 1277,
	"./EmailTool/fluxxor/stores/FilterTool.js": 1277,
	"./EmailTool/fluxxor/stores/Table": 1276,
	"./EmailTool/fluxxor/stores/Table.js": 1276,
	"./FeaturedArticles": 1923,
	"./FeaturedArticles.js": 1923,
	"./FeaturedArticles/Card": 1298,
	"./FeaturedArticles/Card.jsx": 1298,
	"./FeaturedArticles/CategorySelector": 1299,
	"./FeaturedArticles/CategorySelector.jsx": 1299,
	"./FeaturedArticles/Content": 1300,
	"./FeaturedArticles/Content.jsx": 1300,
	"./FeaturedArticles/Main": 1924,
	"./FeaturedArticles/Main.jsx": 1924,
	"./FeaturedMultimedia/Main": 261,
	"./FeaturedMultimedia/Main.jsx": 261,
	"./FeaturedMultimedia/MultimediaCard": 262,
	"./FeaturedMultimedia/MultimediaCard.jsx": 262,
	"./FileDrop": 1098,
	"./FileDrop.jsx": 1098,
	"./FinancialRelationships": 1925,
	"./FinancialRelationships.js": 1925,
	"./FinancialRelationships/AddDisclosureModal": 353,
	"./FinancialRelationships/AddDisclosureModal.jsx": 353,
	"./FinancialRelationships/RelationshipRow": 1301,
	"./FinancialRelationships/RelationshipRow.jsx": 1301,
	"./FinancialRelationships/RelationshipRows": 1926,
	"./FinancialRelationships/RelationshipRows.jsx": 1926,
	"./Forms": 1927,
	"./Forms.js": 1927,
	"./Forms/Post": 1302,
	"./Forms/Post.jsx": 1302,
	"./GettingStarted": 1928,
	"./GettingStarted.jsx": 1928,
	"./Guides/AcademicChannelGuide": 388,
	"./Guides/AcademicChannelGuide.jsx": 388,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities": 394,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities.jsx": 394,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles": 393,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles.jsx": 393,
	"./Guides/AcademicChannelsPages/ChannelTypes": 391,
	"./Guides/AcademicChannelsPages/ChannelTypes.jsx": 391,
	"./Guides/AcademicChannelsPages/Faq": 392,
	"./Guides/AcademicChannelsPages/Faq.jsx": 392,
	"./Guides/AcademicChannelsPages/Introduction": 390,
	"./Guides/AcademicChannelsPages/Introduction.jsx": 390,
	"./Guides/AuthorGuide": 395,
	"./Guides/AuthorGuide.jsx": 395,
	"./Guides/AuthorPages/AcceptedArticleTypes": 398,
	"./Guides/AuthorPages/AcceptedArticleTypes.jsx": 398,
	"./Guides/AuthorPages/ArtificialIntelligence": 413,
	"./Guides/AuthorPages/ArtificialIntelligence.jsx": 413,
	"./Guides/AuthorPages/AuthorRoles": 401,
	"./Guides/AuthorPages/AuthorRoles.jsx": 401,
	"./Guides/AuthorPages/BusinessModel": 422,
	"./Guides/AuthorPages/BusinessModel.jsx": 422,
	"./Guides/AuthorPages/CommentingPolicies": 419,
	"./Guides/AuthorPages/CommentingPolicies.jsx": 419,
	"./Guides/AuthorPages/Confidentiality": 418,
	"./Guides/AuthorPages/Confidentiality.jsx": 418,
	"./Guides/AuthorPages/ConflictsOfInterest": 410,
	"./Guides/AuthorPages/ConflictsOfInterest.jsx": 410,
	"./Guides/AuthorPages/CopyrightAndLicensing": 420,
	"./Guides/AuthorPages/CopyrightAndLicensing.jsx": 420,
	"./Guides/AuthorPages/DataCitationAndTransparency": 414,
	"./Guides/AuthorPages/DataCitationAndTransparency.jsx": 414,
	"./Guides/AuthorPages/DisciplineSpecificStandards": 417,
	"./Guides/AuthorPages/DisciplineSpecificStandards.jsx": 417,
	"./Guides/AuthorPages/FreePublication": 397,
	"./Guides/AuthorPages/FreePublication.jsx": 397,
	"./Guides/AuthorPages/HumanAndAnimalSubjects": 411,
	"./Guides/AuthorPages/HumanAndAnimalSubjects.jsx": 411,
	"./Guides/AuthorPages/IcmjeRequirements": 408,
	"./Guides/AuthorPages/IcmjeRequirements.jsx": 408,
	"./Guides/AuthorPages/Introduction": 396,
	"./Guides/AuthorPages/Introduction.jsx": 396,
	"./Guides/AuthorPages/ManagingPeerReview": 403,
	"./Guides/AuthorPages/ManagingPeerReview.jsx": 403,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics": 409,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics.jsx": 409,
	"./Guides/AuthorPages/Preregistration": 415,
	"./Guides/AuthorPages/Preregistration.jsx": 415,
	"./Guides/AuthorPages/PromotingYourResearch": 406,
	"./Guides/AuthorPages/PromotingYourResearch.jsx": 406,
	"./Guides/AuthorPages/RaceAndEthnicity": 412,
	"./Guides/AuthorPages/RaceAndEthnicity.jsx": 412,
	"./Guides/AuthorPages/References": 404,
	"./Guides/AuthorPages/References.jsx": 404,
	"./Guides/AuthorPages/ReplicationStudies": 416,
	"./Guides/AuthorPages/ReplicationStudies.jsx": 416,
	"./Guides/AuthorPages/RetractionPolicy": 421,
	"./Guides/AuthorPages/RetractionPolicy.jsx": 421,
	"./Guides/AuthorPages/SeoTips": 405,
	"./Guides/AuthorPages/SeoTips.jsx": 405,
	"./Guides/AuthorPages/SingleBlindedPeerReview": 407,
	"./Guides/AuthorPages/SingleBlindedPeerReview.jsx": 407,
	"./Guides/AuthorPages/StepByStepOverview": 400,
	"./Guides/AuthorPages/StepByStepOverview.jsx": 400,
	"./Guides/AuthorPages/SubmittingAnArticle": 402,
	"./Guides/AuthorPages/SubmittingAnArticle.jsx": 402,
	"./Guides/AuthorPages/UnacceptedArticleTypes": 399,
	"./Guides/AuthorPages/UnacceptedArticleTypes.jsx": 399,
	"./Guides/Card": 87,
	"./Guides/Card.jsx": 87,
	"./Guides/Footer": 163,
	"./Guides/Footer.jsx": 163,
	"./Guides/GuestEditorGuide": 423,
	"./Guides/GuestEditorGuide.jsx": 423,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions": 427,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions.jsx": 427,
	"./Guides/GuestEditorPages/GettingStarted": 425,
	"./Guides/GuestEditorPages/GettingStarted.jsx": 425,
	"./Guides/GuestEditorPages/Introduction": 424,
	"./Guides/GuestEditorPages/Introduction.jsx": 424,
	"./Guides/GuestEditorPages/StepByStepInstructions": 426,
	"./Guides/GuestEditorPages/StepByStepInstructions.jsx": 426,
	"./Guides/Main": 1532,
	"./Guides/Main.jsx": 1532,
	"./Guides/MediaGuide": 428,
	"./Guides/MediaGuide.jsx": 428,
	"./Guides/MediaPages/AddingFigures": 433,
	"./Guides/MediaPages/AddingFigures.jsx": 433,
	"./Guides/MediaPages/AddingInteractiveModels": 440,
	"./Guides/MediaPages/AddingInteractiveModels.jsx": 440,
	"./Guides/MediaPages/AddingMedia": 429,
	"./Guides/MediaPages/AddingMedia.jsx": 429,
	"./Guides/MediaPages/AddingTables": 437,
	"./Guides/MediaPages/AddingTables.jsx": 437,
	"./Guides/MediaPages/AddingVideos": 439,
	"./Guides/MediaPages/AddingVideos.jsx": 439,
	"./Guides/MediaPages/FigureRequirements": 432,
	"./Guides/MediaPages/FigureRequirements.jsx": 432,
	"./Guides/MediaPages/GenerativeAiImages": 435,
	"./Guides/MediaPages/GenerativeAiImages.jsx": 435,
	"./Guides/MediaPages/MentioningMedia": 431,
	"./Guides/MediaPages/MentioningMedia.jsx": 431,
	"./Guides/MediaPages/PrivacyAndPermissionIssues": 441,
	"./Guides/MediaPages/PrivacyAndPermissionIssues.jsx": 441,
	"./Guides/MediaPages/TableRequirements": 436,
	"./Guides/MediaPages/TableRequirements.jsx": 436,
	"./Guides/MediaPages/TitleLegendsNumbering": 430,
	"./Guides/MediaPages/TitleLegendsNumbering.jsx": 430,
	"./Guides/MediaPages/UnacceptableFigureExamples": 434,
	"./Guides/MediaPages/UnacceptableFigureExamples.jsx": 434,
	"./Guides/MediaPages/UnacceptableTableExamples": 438,
	"./Guides/MediaPages/UnacceptableTableExamples.jsx": 438,
	"./Guides/Page": 1533,
	"./Guides/Page.jsx": 1533,
	"./Guides/ResultCard": 389,
	"./Guides/ResultCard.jsx": 389,
	"./Guides/ReviewerGuide": 442,
	"./Guides/ReviewerGuide.jsx": 442,
	"./Guides/ReviewerPages/Introduction": 447,
	"./Guides/ReviewerPages/Introduction.jsx": 447,
	"./Guides/ReviewerPages/RereviewProcess": 445,
	"./Guides/ReviewerPages/RereviewProcess.jsx": 445,
	"./Guides/ReviewerPages/StepByStepOverview": 444,
	"./Guides/ReviewerPages/StepByStepOverview.jsx": 444,
	"./Guides/ReviewerPages/SuspectPlagiarism": 446,
	"./Guides/ReviewerPages/SuspectPlagiarism.jsx": 446,
	"./Guides/ReviewerPages/WhyReviewWithCureus": 443,
	"./Guides/ReviewerPages/WhyReviewWithCureus.jsx": 443,
	"./Guides/Root": 1534,
	"./Guides/Root.jsx": 1534,
	"./Guides/SearchBar": 85,
	"./Guides/SearchBar.jsx": 85,
	"./Guides/SearchResults": 46,
	"./Guides/SearchResults.jsx": 46,
	"./Guides/SideNavMenu": 165,
	"./Guides/SideNavMenu.jsx": 165,
	"./Guides/TopNavMenu": 164,
	"./Guides/TopNavMenu.jsx": 164,
	"./History": 1929,
	"./History.js": 1929,
	"./History/HistoryModal": 17,
	"./History/HistoryModal.jsx": 17,
	"./History/Main": 1930,
	"./History/Main.jsx": 1930,
	"./Home/ArticleCard": 82,
	"./Home/ArticleCard.jsx": 82,
	"./Home/CureusUCard": 84,
	"./Home/CureusUCard.jsx": 84,
	"./Home/CureusUpdates": 224,
	"./Home/CureusUpdates.jsx": 224,
	"./Home/CureusUpdatesHistoryTable": 938,
	"./Home/CureusUpdatesHistoryTable.jsx": 938,
	"./Home/FeaturedContent": 220,
	"./Home/FeaturedContent.jsx": 220,
	"./Home/FeaturedContentCard": 221,
	"./Home/FeaturedContentCard.jsx": 221,
	"./Home/FeaturedContentCarousel": 939,
	"./Home/FeaturedContentCarousel.jsx": 939,
	"./Home/FeaturedContentModal": 222,
	"./Home/FeaturedContentModal.jsx": 222,
	"./Home/MetricsCard": 81,
	"./Home/MetricsCard.jsx": 81,
	"./Home/NewsCard": 83,
	"./Home/NewsCard.jsx": 83,
	"./Home/Search": 940,
	"./Home/Search.jsx": 940,
	"./Home/VideoImage": 941,
	"./Home/VideoImage.jsx": 941,
	"./Home/VideoModal": 226,
	"./Home/VideoModal.jsx": 226,
	"./HomepageFeaturedArticles/Card": 366,
	"./HomepageFeaturedArticles/Card.jsx": 366,
	"./HomepageFeaturedArticles/Content": 227,
	"./HomepageFeaturedArticles/Content.jsx": 227,
	"./HomepageFeaturedArticles/Main": 942,
	"./HomepageFeaturedArticles/Main.jsx": 942,
	"./HomepageHeros": 943,
	"./HomepageHeros.js": 943,
	"./HomepageHeros/DeleteHeroModal": 219,
	"./HomepageHeros/DeleteHeroModal.jsx": 219,
	"./HomepageHeros/Hero": 218,
	"./HomepageHeros/Hero.jsx": 218,
	"./HomepageHeros/Main": 217,
	"./HomepageHeros/Main.jsx": 217,
	"./HomepageV2/Discussions/Main": 944,
	"./HomepageV2/Discussions/Main.jsx": 944,
	"./HomepageV2/Discussions/NewDiscussionCard": 228,
	"./HomepageV2/Discussions/NewDiscussionCard.jsx": 228,
	"./HomepageV2/FeaturedMultiMedia/Main": 945,
	"./HomepageV2/FeaturedMultiMedia/Main.jsx": 945,
	"./HomepageV2Carousel/HomepageCarousel": 946,
	"./HomepageV2Carousel/HomepageCarousel.jsx": 946,
	"./HomepageV2Carousel/Slide": 229,
	"./HomepageV2Carousel/Slide.jsx": 229,
	"./Howto": 1931,
	"./Howto.js": 1931,
	"./Howto/Abstract": 1303,
	"./Howto/Abstract.jsx": 1303,
	"./Howto/ArticleCitations": 1304,
	"./Howto/ArticleCitations.jsx": 1304,
	"./Howto/ArticleMedia": 1305,
	"./Howto/ArticleMedia.jsx": 1305,
	"./Howto/ArticleSubheaders": 1306,
	"./Howto/ArticleSubheaders.jsx": 1306,
	"./Howto/Authors": 1307,
	"./Howto/Authors.jsx": 1307,
	"./Howto/Close": 1308,
	"./Howto/Close.jsx": 1308,
	"./Howto/Content": 1309,
	"./Howto/Content.jsx": 1309,
	"./Howto/Keywords": 1310,
	"./Howto/Keywords.jsx": 1310,
	"./Howto/Main": 1932,
	"./Howto/Main.jsx": 1932,
	"./Howto/MediaMentions": 1311,
	"./Howto/MediaMentions.jsx": 1311,
	"./Howto/MinMax": 1317,
	"./Howto/MinMax.jsx": 1317,
	"./Howto/Nav": 1312,
	"./Howto/Nav.jsx": 1312,
	"./Howto/Next": 1313,
	"./Howto/Next.jsx": 1313,
	"./Howto/Prev": 1314,
	"./Howto/Prev.jsx": 1314,
	"./Howto/Range": 1315,
	"./Howto/Range.jsx": 1315,
	"./Howto/Title": 572,
	"./Howto/Title.jsx": 572,
	"./Howto/TopBar": 1316,
	"./Howto/TopBar.jsx": 1316,
	"./HumanSubjects": 1933,
	"./HumanSubjects.js": 1933,
	"./HumanSubjects/UploadProofModal": 1318,
	"./HumanSubjects/UploadProofModal.jsx": 1318,
	"./HumanSubjects/Validator": 1934,
	"./HumanSubjects/Validator.jsx": 1934,
	"./ImageUploader": 1935,
	"./ImageUploader.js": 1935,
	"./ImageUploader/V1": 1936,
	"./ImageUploader/V1.jsx": 1936,
	"./ImageUploader/V2": 1937,
	"./ImageUploader/V2.jsx": 1937,
	"./InstitutionCarousel/Main": 1535,
	"./InstitutionCarousel/Main.jsx": 1535,
	"./InstitutionCarousel/Post": 448,
	"./InstitutionCarousel/Post.jsx": 448,
	"./Judgeship": 1938,
	"./Judgeship.js": 1938,
	"./Judgeship/JudgeInputField": 1319,
	"./Judgeship/JudgeInputField.jsx": 1319,
	"./Judgeship/JudgeRows": 1320,
	"./Judgeship/JudgeRows.jsx": 1320,
	"./Judgeship/JudgeshipModal": 1321,
	"./Judgeship/JudgeshipModal.jsx": 1321,
	"./Judgeship/Main": 1939,
	"./Judgeship/Main.jsx": 1939,
	"./KeywordTool": 1452,
	"./KeywordTool.jsx": 1452,
	"./Likes/LikeUser": 547,
	"./Likes/LikeUser.jsx": 547,
	"./Likes/Modal": 285,
	"./Likes/Modal.jsx": 285,
	"./Media": 1940,
	"./Media.js": 1940,
	"./Media/AttachmentInsertMixin": 129,
	"./Media/AttachmentInsertMixin.js": 129,
	"./Media/AttachmentUploadMixin": 354,
	"./Media/AttachmentUploadMixin.js": 354,
	"./Media/CheckList": 1322,
	"./Media/CheckList.jsx": 1322,
	"./Media/Details": 130,
	"./Media/Details.jsx": 130,
	"./Media/Edit": 1323,
	"./Media/Edit.jsx": 1323,
	"./Media/EditorModalTrigger": 1941,
	"./Media/EditorModalTrigger.jsx": 1941,
	"./Media/Errors": 179,
	"./Media/Errors.jsx": 179,
	"./Media/Figure": 1325,
	"./Media/Figure.jsx": 1325,
	"./Media/InteractiveModel": 1328,
	"./Media/InteractiveModel.jsx": 1328,
	"./Media/Table": 1326,
	"./Media/Table.jsx": 1326,
	"./Media/TooManyAttachments": 1324,
	"./Media/TooManyAttachments.jsx": 1324,
	"./Media/Video": 1327,
	"./Media/Video.jsx": 1327,
	"./MediaLibrary": 1942,
	"./MediaLibrary.js": 1942,
	"./MediaLibrary/AttachmentUploadMixin": 1943,
	"./MediaLibrary/AttachmentUploadMixin.js": 1943,
	"./MediaLibrary/DeleteModal": 1329,
	"./MediaLibrary/DeleteModal.jsx": 1329,
	"./MediaLibrary/DeleteModalTrigger": 1944,
	"./MediaLibrary/DeleteModalTrigger.jsx": 1944,
	"./Misc": 1945,
	"./Misc.js": 1945,
	"./Misc/Authorships": 951,
	"./Misc/Authorships.jsx": 951,
	"./Misc/PublishingConfirmationModal": 1468,
	"./Misc/PublishingConfirmationModal.jsx": 1468,
	"./Misc/References": 950,
	"./Misc/References.jsx": 950,
	"./Modal": 3,
	"./Modal.jsx": 3,
	"./MostPopularArticles/Card": 136,
	"./MostPopularArticles/Card.jsx": 136,
	"./MostPopularArticles/Index": 1536,
	"./MostPopularArticles/Index.jsx": 1536,
	"./MultiAdd/Main": 1946,
	"./MultiAdd/Main.jsx": 1946,
	"./MultiAdd/Row": 1330,
	"./MultiAdd/Row.jsx": 1330,
	"./NewArticleIndex/ArticleDateSelector": 132,
	"./NewArticleIndex/ArticleDateSelector.jsx": 132,
	"./NewArticleIndex/FiltersModal": 449,
	"./NewArticleIndex/FiltersModal.jsx": 449,
	"./NewArticleIndex/Header": 206,
	"./NewArticleIndex/Header.jsx": 206,
	"./NewArticleIndex/LeftSidebar/Carat": 167,
	"./NewArticleIndex/LeftSidebar/Carat.jsx": 167,
	"./NewArticleIndex/LeftSidebar/Categories": 450,
	"./NewArticleIndex/LeftSidebar/Categories.jsx": 450,
	"./NewArticleIndex/LeftSidebar/Filters": 166,
	"./NewArticleIndex/LeftSidebar/Filters.jsx": 166,
	"./NewArticleIndex/LeftSidebar/Sidebar": 453,
	"./NewArticleIndex/LeftSidebar/Sidebar.jsx": 453,
	"./NewArticleIndex/LeftSidebar/SpecialtyPromotion": 454,
	"./NewArticleIndex/LeftSidebar/SpecialtyPromotion.jsx": 454,
	"./NewArticleIndex/LeftSidebar/Types": 451,
	"./NewArticleIndex/LeftSidebar/Types.jsx": 451,
	"./NewArticleIndex/Main": 1537,
	"./NewArticleIndex/Main.jsx": 1537,
	"./NewArticleIndex/NewAdvancedSearch": 460,
	"./NewArticleIndex/NewAdvancedSearch.jsx": 460,
	"./NewArticleIndex/NewAdvancedSearchRow": 461,
	"./NewArticleIndex/NewAdvancedSearchRow.jsx": 461,
	"./NewArticleIndex/NewSearch": 459,
	"./NewArticleIndex/NewSearch.jsx": 459,
	"./NewArticleIndex/RightSidebar/Authors": 207,
	"./NewArticleIndex/RightSidebar/Authors.jsx": 207,
	"./NewArticleIndex/RightSidebar/Contributors": 456,
	"./NewArticleIndex/RightSidebar/Contributors.jsx": 456,
	"./NewArticleIndex/RightSidebar/PictureBubbles": 457,
	"./NewArticleIndex/RightSidebar/PictureBubbles.jsx": 457,
	"./NewArticleIndex/RightSidebar/PopularArticles": 458,
	"./NewArticleIndex/RightSidebar/PopularArticles.jsx": 458,
	"./NewArticleIndex/RightSidebar/Reviewers": 208,
	"./NewArticleIndex/RightSidebar/Reviewers.jsx": 208,
	"./NewArticleIndex/RightSidebar/Sidebar": 455,
	"./NewArticleIndex/RightSidebar/Sidebar.jsx": 455,
	"./NewArticleIndex/RightSidebar/TrendingTopics": 133,
	"./NewArticleIndex/RightSidebar/TrendingTopics.jsx": 133,
	"./NewArticleIndex/SortButton": 462,
	"./NewArticleIndex/SortButton.jsx": 462,
	"./NewArticleIndex/SubscribeButton": 452,
	"./NewArticleIndex/SubscribeButton.jsx": 452,
	"./NewCollectionsDashboard/ApproveOrRejectModal": 1331,
	"./NewCollectionsDashboard/ApproveOrRejectModal.jsx": 1331,
	"./NewCollectionsDashboard/ColleagueInvitationModal": 1332,
	"./NewCollectionsDashboard/ColleagueInvitationModal.jsx": 1332,
	"./NewCollectionsDashboard/InfoWidget": 1333,
	"./NewCollectionsDashboard/InfoWidget.jsx": 1333,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetCollectionApplication": 1336,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetCollectionApplication.jsx": 1336,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetInviteAndMetrics": 1334,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetInviteAndMetrics.jsx": 1334,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetStart": 1335,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetStart.jsx": 1335,
	"./NewCollectionsDashboard/Main": 1947,
	"./NewCollectionsDashboard/Main.jsx": 1947,
	"./NewCollectionsDashboard/MyCollections": 1337,
	"./NewCollectionsDashboard/MyCollections.jsx": 1337,
	"./NewCollectionsDashboard/PendingArticles/PendingArticleRow": 1347,
	"./NewCollectionsDashboard/PendingArticles/PendingArticleRow.jsx": 1347,
	"./NewCollectionsDashboard/PendingArticles/PendingArticlesTab": 1346,
	"./NewCollectionsDashboard/PendingArticles/PendingArticlesTab.jsx": 1346,
	"./NewCollectionsDashboard/PendingArticles/Table": 1348,
	"./NewCollectionsDashboard/PendingArticles/Table.jsx": 1348,
	"./NewCollectionsDashboard/PublishedTab/CollectionLockSubsModal": 1345,
	"./NewCollectionsDashboard/PublishedTab/CollectionLockSubsModal.jsx": 1345,
	"./NewCollectionsDashboard/PublishedTab/CollectionRow": 1343,
	"./NewCollectionsDashboard/PublishedTab/CollectionRow.jsx": 1343,
	"./NewCollectionsDashboard/PublishedTab/PublishedTab": 1342,
	"./NewCollectionsDashboard/PublishedTab/PublishedTab.jsx": 1342,
	"./NewCollectionsDashboard/PublishedTab/Table": 1344,
	"./NewCollectionsDashboard/PublishedTab/Table.jsx": 1344,
	"./NewCollectionsDashboard/RejectedTab/CollectionRejectedModal": 1351,
	"./NewCollectionsDashboard/RejectedTab/CollectionRejectedModal.jsx": 1351,
	"./NewCollectionsDashboard/RejectedTab/RejectedCollectionCard": 1350,
	"./NewCollectionsDashboard/RejectedTab/RejectedCollectionCard.jsx": 1350,
	"./NewCollectionsDashboard/RejectedTab/RejectedTab": 1349,
	"./NewCollectionsDashboard/RejectedTab/RejectedTab.jsx": 1349,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionCard": 1339,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionCard.jsx": 1339,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionDeleteModal": 1340,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionDeleteModal.jsx": 1340,
	"./NewCollectionsDashboard/UnpublishedTab/DeferralModal": 1341,
	"./NewCollectionsDashboard/UnpublishedTab/DeferralModal.jsx": 1341,
	"./NewCollectionsDashboard/UnpublishedTab/UnpublishedTab": 1338,
	"./NewCollectionsDashboard/UnpublishedTab/UnpublishedTab.jsx": 1338,
	"./NewDashboard/Abstract": 1352,
	"./NewDashboard/Abstract.jsx": 1352,
	"./NewDashboard/Article": 1353,
	"./NewDashboard/Article.jsx": 1353,
	"./NewDashboard/ArticleExpanded": 1354,
	"./NewDashboard/ArticleExpanded.jsx": 1354,
	"./NewDashboard/CoauthoredArticle": 1355,
	"./NewDashboard/CoauthoredArticle.jsx": 1355,
	"./NewDashboard/DeletePosterAbstractModal": 356,
	"./NewDashboard/DeletePosterAbstractModal.jsx": 356,
	"./NewDashboard/EditorMessageModal": 357,
	"./NewDashboard/EditorMessageModal.jsx": 357,
	"./NewDashboard/InfoWidget": 1361,
	"./NewDashboard/InfoWidget.jsx": 1361,
	"./NewDashboard/Main": 1948,
	"./NewDashboard/Main.jsx": 1948,
	"./NewDashboard/Poster": 1362,
	"./NewDashboard/Poster.jsx": 1362,
	"./NewDashboard/PrimaryButton/Deferred": 1359,
	"./NewDashboard/PrimaryButton/Deferred.jsx": 1359,
	"./NewDashboard/PrimaryButton/InReview": 1358,
	"./NewDashboard/PrimaryButton/InReview.jsx": 1358,
	"./NewDashboard/PrimaryButton/PreviewPublishButton": 1949,
	"./NewDashboard/PrimaryButton/PreviewPublishButton.jsx": 1949,
	"./NewDashboard/PrimaryButton/RereviewsComplete": 1357,
	"./NewDashboard/PrimaryButton/RereviewsComplete.jsx": 1357,
	"./NewDashboard/PrimaryButton/ReviewsComplete": 1356,
	"./NewDashboard/PrimaryButton/ReviewsComplete.jsx": 1356,
	"./NewDashboard/PublishedArticle": 1360,
	"./NewDashboard/PublishedArticle.jsx": 1360,
	"./NewPersonIndex/DropDown": 573,
	"./NewPersonIndex/DropDown.jsx": 573,
	"./NewPersonIndex/DropDownInput": 574,
	"./NewPersonIndex/DropDownInput.jsx": 574,
	"./NewPersonIndex/FiltersModal": 1363,
	"./NewPersonIndex/FiltersModal.jsx": 1363,
	"./NewPersonIndex/InstitutionInput": 1364,
	"./NewPersonIndex/InstitutionInput.jsx": 1364,
	"./NewPersonIndex/LeftSidebar/Carat": 1365,
	"./NewPersonIndex/LeftSidebar/Carat.jsx": 1365,
	"./NewPersonIndex/LeftSidebar/Filters": 358,
	"./NewPersonIndex/LeftSidebar/Filters.jsx": 358,
	"./NewPersonIndex/LeftSidebar/List": 575,
	"./NewPersonIndex/LeftSidebar/List.jsx": 575,
	"./NewPersonIndex/LeftSidebar/Sidebar": 1366,
	"./NewPersonIndex/LeftSidebar/Sidebar.jsx": 1366,
	"./NewPersonIndex/Main": 1950,
	"./NewPersonIndex/Main.jsx": 1950,
	"./NewPersonIndex/MobilePersonRowCard": 1371,
	"./NewPersonIndex/MobilePersonRowCard.jsx": 1371,
	"./NewPersonIndex/PerPageViewSelector": 1373,
	"./NewPersonIndex/PerPageViewSelector.jsx": 1373,
	"./NewPersonIndex/PersonRowCard": 1370,
	"./NewPersonIndex/PersonRowCard.jsx": 1370,
	"./NewPersonIndex/ResultsHeader": 1374,
	"./NewPersonIndex/ResultsHeader.jsx": 1374,
	"./NewPersonIndex/RightSidebar": 1367,
	"./NewPersonIndex/RightSidebar.jsx": 1367,
	"./NewPersonIndex/SearchFields": 1368,
	"./NewPersonIndex/SearchFields.jsx": 1368,
	"./NewPersonIndex/SearchResults": 1369,
	"./NewPersonIndex/SearchResults.jsx": 1369,
	"./NewPersonIndex/SortButton": 183,
	"./NewPersonIndex/SortButton.jsx": 183,
	"./NewPersonIndex/SortButtons": 1372,
	"./NewPersonIndex/SortButtons.jsx": 1372,
	"./NewReviewsDashboard/DashboardKeywordTool": 168,
	"./NewReviewsDashboard/DashboardKeywordTool.jsx": 168,
	"./NewReviewsDashboard/InfoWidget": 253,
	"./NewReviewsDashboard/InfoWidget.jsx": 253,
	"./NewReviewsDashboard/KeywordAutoSuggester": 463,
	"./NewReviewsDashboard/KeywordAutoSuggester.jsx": 463,
	"./NewReviewsDashboard/Main": 1538,
	"./NewReviewsDashboard/Main.jsx": 1538,
	"./NewReviewsDashboard/Reviewership": 464,
	"./NewReviewsDashboard/Reviewership.jsx": 464,
	"./NewsroomCarousel": 1951,
	"./NewsroomCarousel.js": 1951,
	"./NewsroomCarousel/Main": 1952,
	"./NewsroomCarousel/Main.jsx": 1952,
	"./NewsroomCarousel/Post": 1375,
	"./NewsroomCarousel/Post.jsx": 1375,
	"./NewsroomInside/InsideList": 1953,
	"./NewsroomInside/InsideList.jsx": 1953,
	"./NewsroomInside/NewsroomInside": 1376,
	"./NewsroomInside/NewsroomInside.jsx": 1376,
	"./NewsroomPosts": 1954,
	"./NewsroomPosts.js": 1954,
	"./NewsroomPosts/Inside": 1377,
	"./NewsroomPosts/Inside.jsx": 1377,
	"./NewsroomPosts/InsideListItem": 1378,
	"./NewsroomPosts/InsideListItem.jsx": 1378,
	"./NewsroomPosts/NewsroomMain": 1955,
	"./NewsroomPosts/NewsroomMain.jsx": 1955,
	"./NotificationsCenter/AdviserModal": 141,
	"./NotificationsCenter/AdviserModal.jsx": 141,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 142,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 142,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 143,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 143,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal": 144,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal.jsx": 144,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 145,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 145,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 146,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 146,
	"./NotificationsCenter/DraftReadyForSubmissionModal": 147,
	"./NotificationsCenter/DraftReadyForSubmissionModal.jsx": 147,
	"./NotificationsCenter/GuestEditorModal": 148,
	"./NotificationsCenter/GuestEditorModal.jsx": 148,
	"./NotificationsCenter/Main": 149,
	"./NotificationsCenter/Main.jsx": 149,
	"./NotificationsCenter/ReferralProgramModal": 150,
	"./NotificationsCenter/ReferralProgramModal.jsx": 150,
	"./NotificationsCenter/ReviewerModal": 151,
	"./NotificationsCenter/ReviewerModal.jsx": 151,
	"./NpiModal/Main": 1956,
	"./NpiModal/Main.jsx": 1956,
	"./NpiModal/NpiModal": 1379,
	"./NpiModal/NpiModal.jsx": 1379,
	"./OnDemand/Article": 210,
	"./OnDemand/Article.jsx": 210,
	"./OnDemand/ArticleTabs": 551,
	"./OnDemand/ArticleTabs.jsx": 551,
	"./OnDemand/Intro": 549,
	"./OnDemand/Intro.jsx": 549,
	"./OnDemand/Main": 247,
	"./OnDemand/Main.jsx": 247,
	"./OnDemand/OnDemandModal": 548,
	"./OnDemand/OnDemandModal.jsx": 548,
	"./OnDemand/Selection": 550,
	"./OnDemand/Selection.jsx": 550,
	"./PastCompetitions/Card": 465,
	"./PastCompetitions/Card.jsx": 465,
	"./PastCompetitions/Index": 1539,
	"./PastCompetitions/Index.jsx": 1539,
	"./PastCompetitions/Tab": 467,
	"./PastCompetitions/Tab.jsx": 467,
	"./PastCompetitions/TabComponent": 466,
	"./PastCompetitions/TabComponent.jsx": 466,
	"./PaymentConfirmation": 1957,
	"./PaymentConfirmation.js": 1957,
	"./PaymentConfirmation/Main": 1958,
	"./PaymentConfirmation/Main.jsx": 1958,
	"./PeerReviewReport/Main": 1959,
	"./PeerReviewReport/Main.jsx": 1959,
	"./PeerReviewReport/PeerReviewQuestion": 576,
	"./PeerReviewReport/PeerReviewQuestion.jsx": 576,
	"./PersonIndex": 1960,
	"./PersonIndex.js": 1960,
	"./PersonIndex/Filters": 1380,
	"./PersonIndex/Filters.jsx": 1380,
	"./PersonIndex/Main": 1961,
	"./PersonIndex/Main.jsx": 1961,
	"./PersonIndex/Search": 1384,
	"./PersonIndex/Search.jsx": 1384,
	"./PersonIndex/Sort": 1381,
	"./PersonIndex/Sort.jsx": 1381,
	"./PersonIndex/Specialties": 1382,
	"./PersonIndex/Specialties.jsx": 1382,
	"./PersonIndex/SpecialtiesModal": 1383,
	"./PersonIndex/SpecialtiesModal.jsx": 1383,
	"./PicturePrognosis/CompletedAnswer": 298,
	"./PicturePrognosis/CompletedAnswer.jsx": 298,
	"./PicturePrognosis/HistoryTable": 1962,
	"./PicturePrognosis/HistoryTable.jsx": 1962,
	"./PicturePrognosis/New": 295,
	"./PicturePrognosis/New.jsx": 295,
	"./PicturePrognosis/QuestionInput": 296,
	"./PicturePrognosis/QuestionInput.jsx": 296,
	"./PicturePrognosis/QueueModal": 297,
	"./PicturePrognosis/QueueModal.jsx": 297,
	"./PicturePrognosisBacklog/Main": 1963,
	"./PicturePrognosisBacklog/Main.jsx": 1963,
	"./PicturePrognosisBacklog/PictureQuizCard": 359,
	"./PicturePrognosisBacklog/PictureQuizCard.jsx": 359,
	"./PicturePrognosisBacklog/Show": 1964,
	"./PicturePrognosisBacklog/Show.jsx": 1964,
	"./PicturePrognosisHome/AnswerBarRow": 104,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 104,
	"./PicturePrognosisHome/AnswerOption": 230,
	"./PicturePrognosisHome/AnswerOption.jsx": 230,
	"./PicturePrognosisHome/AnswerOutcome": 231,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 231,
	"./PicturePrognosisHome/Clarification": 232,
	"./PicturePrognosisHome/Clarification.jsx": 232,
	"./PicturePrognosisHome/Landing": 947,
	"./PicturePrognosisHome/Landing.jsx": 947,
	"./PicturePrognosisHome/Widget": 283,
	"./PicturePrognosisHome/Widget.jsx": 283,
	"./Popper": 582,
	"./Popper.js": 582,
	"./Popper/Link": 100,
	"./Popper/Link.jsx": 100,
	"./Popper/Main": 246,
	"./Popper/Main.jsx": 246,
	"./PosterUploader": 1965,
	"./PosterUploader.js": 1965,
	"./PosterUploader/EditFile": 1385,
	"./PosterUploader/EditFile.jsx": 1385,
	"./PosterUploader/Main": 1966,
	"./PosterUploader/Main.jsx": 1966,
	"./PosterUploader/NewFile": 1386,
	"./PosterUploader/NewFile.jsx": 1386,
	"./Publishing": 1967,
	"./Publishing.js": 1967,
	"./Publishing/ChannelTile": 1387,
	"./Publishing/ChannelTile.jsx": 1387,
	"./Publishing/Channels/ChannelFilter": 1388,
	"./Publishing/Channels/ChannelFilter.jsx": 1388,
	"./Publishing/Channels/ChannelListings": 1389,
	"./Publishing/Channels/ChannelListings.jsx": 1389,
	"./Publishing/Channels/ChannelMapOrList": 1390,
	"./Publishing/Channels/ChannelMapOrList.jsx": 1390,
	"./Publishing/Channels/ChannelSelector": 1968,
	"./Publishing/Channels/ChannelSelector.jsx": 1968,
	"./Publishing/Channels/SubChannelModal": 1392,
	"./Publishing/Channels/SubChannelModal.jsx": 1392,
	"./Publishing/Channels/ToggleViewButton": 1391,
	"./Publishing/Channels/ToggleViewButton.jsx": 1391,
	"./Publishing/CoiResponsibility": 1969,
	"./Publishing/CoiResponsibility.jsx": 1969,
	"./Publishing/CollectionSelector": 1970,
	"./Publishing/CollectionSelector.jsx": 1970,
	"./Publishing/CollectionTile": 1393,
	"./Publishing/CollectionTile.jsx": 1393,
	"./Publishing/CompetitionSelector": 1971,
	"./Publishing/CompetitionSelector.jsx": 1971,
	"./Publishing/CompetitionTile": 1394,
	"./Publishing/CompetitionTile.jsx": 1394,
	"./Publishing/FilesForEditorReview/EditorFile": 1395,
	"./Publishing/FilesForEditorReview/EditorFile.jsx": 1395,
	"./Publishing/FilesForEditorReview/EditorFileRow": 1396,
	"./Publishing/FilesForEditorReview/EditorFileRow.jsx": 1396,
	"./Publishing/FilesForEditorReview/EditorReviewFilesModal": 1397,
	"./Publishing/FilesForEditorReview/EditorReviewFilesModal.jsx": 1397,
	"./Publishing/FilesForEditorReview/Main": 1972,
	"./Publishing/FilesForEditorReview/Main.jsx": 1972,
	"./Publishing/StudyDesign/Main": 1973,
	"./Publishing/StudyDesign/Main.jsx": 1973,
	"./Publishing/StudyDesign/Question1": 1398,
	"./Publishing/StudyDesign/Question1.jsx": 1398,
	"./Publishing/StudyDesign/Question2": 1399,
	"./Publishing/StudyDesign/Question2.jsx": 1399,
	"./Publishing/StudyDesign/Question3": 1400,
	"./Publishing/StudyDesign/Question3.jsx": 1400,
	"./Publishing/StudyDesign/Question4": 1401,
	"./Publishing/StudyDesign/Question4.jsx": 1401,
	"./Publishing/StudyDesign/Question5": 1402,
	"./Publishing/StudyDesign/Question5.jsx": 1402,
	"./Publishing/StudyDesign/Question6": 1403,
	"./Publishing/StudyDesign/Question6.jsx": 1403,
	"./Publishing/UserTool/Affiliation": 980,
	"./Publishing/UserTool/Affiliation.jsx": 980,
	"./Publishing/UserTool/ApiClient": 36,
	"./Publishing/UserTool/ApiClient.js": 36,
	"./Publishing/UserTool/AuthorDetailsModal": 984,
	"./Publishing/UserTool/AuthorDetailsModal.jsx": 984,
	"./Publishing/UserTool/AuthorForm": 978,
	"./Publishing/UserTool/AuthorForm.jsx": 978,
	"./Publishing/UserTool/ChangeEmailModal": 983,
	"./Publishing/UserTool/ChangeEmailModal.jsx": 983,
	"./Publishing/UserTool/CorrespondentModal": 986,
	"./Publishing/UserTool/CorrespondentModal.jsx": 986,
	"./Publishing/UserTool/DeleteAuthorModal": 985,
	"./Publishing/UserTool/DeleteAuthorModal.jsx": 985,
	"./Publishing/UserTool/Department": 981,
	"./Publishing/UserTool/Department.jsx": 981,
	"./Publishing/UserTool/EditModal": 976,
	"./Publishing/UserTool/EditModal.jsx": 976,
	"./Publishing/UserTool/Institution": 982,
	"./Publishing/UserTool/Institution.jsx": 982,
	"./Publishing/UserTool/Main": 320,
	"./Publishing/UserTool/Main.jsx": 320,
	"./Publishing/UserTool/NewModal": 321,
	"./Publishing/UserTool/NewModal.jsx": 321,
	"./Publishing/UserTool/Row": 977,
	"./Publishing/UserTool/Row.jsx": 977,
	"./ReferenceTool": 1974,
	"./ReferenceTool.js": 1974,
	"./ReferenceTool/DisplayReference": 1404,
	"./ReferenceTool/DisplayReference.jsx": 1404,
	"./ReferenceTool/EditReference": 1405,
	"./ReferenceTool/EditReference.jsx": 1405,
	"./ReferenceTool/FieldSet": 360,
	"./ReferenceTool/FieldSet.jsx": 360,
	"./ReferenceTool/Importer": 1406,
	"./ReferenceTool/Importer.jsx": 1406,
	"./ReferenceTool/Main": 1975,
	"./ReferenceTool/Main.jsx": 1975,
	"./ReferenceTool/NewReference": 1409,
	"./ReferenceTool/NewReference.jsx": 1409,
	"./ReferenceTool/NewReferenceFields": 1410,
	"./ReferenceTool/NewReferenceFields.jsx": 1410,
	"./ReferenceTool/ReferenceField": 361,
	"./ReferenceTool/ReferenceField.jsx": 361,
	"./ReferenceTool/ReferenceMetadataModal": 577,
	"./ReferenceTool/ReferenceMetadataModal.jsx": 577,
	"./ReferenceTool/ReferenceRow": 1408,
	"./ReferenceTool/ReferenceRow.jsx": 1408,
	"./ReferenceTool/ReferencesList": 1407,
	"./ReferenceTool/ReferencesList.jsx": 1407,
	"./Referrals/Index": 1976,
	"./Referrals/Index.jsx": 1976,
	"./ReviewerQuestionnaire/Coi": 1411,
	"./ReviewerQuestionnaire/Coi.jsx": 1411,
	"./ReviewerQuestionnaire/ConclusionCard": 364,
	"./ReviewerQuestionnaire/ConclusionCard.jsx": 364,
	"./ReviewerQuestionnaire/CredibleConclusions": 1412,
	"./ReviewerQuestionnaire/CredibleConclusions.jsx": 1412,
	"./ReviewerQuestionnaire/Label": 180,
	"./ReviewerQuestionnaire/Label.jsx": 180,
	"./ReviewerQuestionnaire/Main": 1977,
	"./ReviewerQuestionnaire/Main.jsx": 1977,
	"./ReviewerQuestionnaire/QuestionAnswerItem": 1413,
	"./ReviewerQuestionnaire/QuestionAnswerItem.jsx": 1413,
	"./ReviewerTool": 1978,
	"./ReviewerTool.js": 1978,
	"./ReviewerTool/AnnotationComment": 578,
	"./ReviewerTool/AnnotationComment.jsx": 578,
	"./ReviewerTool/Main": 1979,
	"./ReviewerTool/Main.jsx": 1979,
	"./ReviewerTool/PointToPointModal": 1416,
	"./ReviewerTool/PointToPointModal.jsx": 1416,
	"./ReviewerTool/QuestionnaireQuestionComment": 1417,
	"./ReviewerTool/QuestionnaireQuestionComment.jsx": 1417,
	"./ReviewerTool/Row": 1415,
	"./ReviewerTool/Row.jsx": 1415,
	"./ReviewerTool/VersionsTable": 1414,
	"./ReviewerTool/VersionsTable.jsx": 1414,
	"./Scoring/Main": 1980,
	"./Scoring/Main.jsx": 1980,
	"./Scoring/ScoringModal": 172,
	"./Scoring/ScoringModal.jsx": 172,
	"./Scoring/Slider": 1068,
	"./Scoring/Slider.jsx": 1068,
	"./Scoring/ThankYouModal": 1067,
	"./Scoring/ThankYouModal.jsx": 1067,
	"./SearchTool": 1981,
	"./SearchTool.js": 1981,
	"./SearchTool/PMCFilters": 544,
	"./SearchTool/PMCFilters.jsx": 544,
	"./SearchTool/PMCOrder": 546,
	"./SearchTool/PMCOrder.jsx": 546,
	"./SearchTool/PMCPagination": 545,
	"./SearchTool/PMCPagination.jsx": 545,
	"./SearchTool/fluxxor/actions": 1982,
	"./SearchTool/fluxxor/actions.js": 1982,
	"./SearchTool/fluxxor/constants": 1418,
	"./SearchTool/fluxxor/constants.js": 1418,
	"./SearchTool/fluxxor/stores/Search": 1983,
	"./SearchTool/fluxxor/stores/Search.js": 1983,
	"./Shared": 1540,
	"./Shared.js": 1540,
	"./Shared/Ad": 28,
	"./Shared/Ad.jsx": 28,
	"./Shared/AuthorsAndReviewersBanModal": 235,
	"./Shared/AuthorsAndReviewersBanModal.jsx": 235,
	"./Shared/Buttons/CollectionButton": 355,
	"./Shared/Buttons/CollectionButton.jsx": 355,
	"./Shared/Categories": 65,
	"./Shared/Categories.jsx": 65,
	"./Shared/Collapse": 539,
	"./Shared/Collapse.jsx": 539,
	"./Shared/ContentCards/AbstractCard": 383,
	"./Shared/ContentCards/AbstractCard.jsx": 383,
	"./Shared/ContentCards/AbstractPosterCard": 538,
	"./Shared/ContentCards/AbstractPosterCard.jsx": 538,
	"./Shared/ContentCards/ArticleCard": 92,
	"./Shared/ContentCards/ArticleCard.jsx": 92,
	"./Shared/ContentCards/ArticleContentCard": 536,
	"./Shared/ContentCards/ArticleContentCard.jsx": 536,
	"./Shared/ContentCards/BigArticleCard": 44,
	"./Shared/ContentCards/BigArticleCard.jsx": 44,
	"./Shared/ContentCards/CorrectionRetractionCard": 250,
	"./Shared/ContentCards/CorrectionRetractionCard.jsx": 250,
	"./Shared/ContentCards/DiscussionCard": 234,
	"./Shared/ContentCards/DiscussionCard.jsx": 234,
	"./Shared/ContentCards/InternalContentCard": 105,
	"./Shared/ContentCards/InternalContentCard.jsx": 105,
	"./Shared/ContentCards/MeetingCard": 541,
	"./Shared/ContentCards/MeetingCard.jsx": 541,
	"./Shared/ContentCards/NewArticleCard": 205,
	"./Shared/ContentCards/NewArticleCard.jsx": 205,
	"./Shared/ContentCards/PersonCard": 204,
	"./Shared/ContentCards/PersonCard.jsx": 204,
	"./Shared/ContentCards/PmcCard": 381,
	"./Shared/ContentCards/PmcCard.jsx": 381,
	"./Shared/ContentCards/PosterCard": 382,
	"./Shared/ContentCards/PosterCard.jsx": 382,
	"./Shared/ContentCards/SmallArticleCard": 64,
	"./Shared/ContentCards/SmallArticleCard.jsx": 64,
	"./Shared/ContentCards/UserCard": 1541,
	"./Shared/ContentCards/UserCard.jsx": 1541,
	"./Shared/DashboardBannerMessage": 1542,
	"./Shared/DashboardBannerMessage.jsx": 1542,
	"./Shared/DropDownArticleStates/Abandoned": 532,
	"./Shared/DropDownArticleStates/Abandoned.jsx": 532,
	"./Shared/DropDownArticleStates/All": 533,
	"./Shared/DropDownArticleStates/All.jsx": 533,
	"./Shared/DropDownArticleStates/Approved": 528,
	"./Shared/DropDownArticleStates/Approved.jsx": 528,
	"./Shared/DropDownArticleStates/Blocked": 531,
	"./Shared/DropDownArticleStates/Blocked.jsx": 531,
	"./Shared/DropDownArticleStates/ChannelEditorApproval": 524,
	"./Shared/DropDownArticleStates/ChannelEditorApproval.jsx": 524,
	"./Shared/DropDownArticleStates/ChannelEditorApprovalDeferred": 525,
	"./Shared/DropDownArticleStates/ChannelEditorApprovalDeferred.jsx": 525,
	"./Shared/DropDownArticleStates/CureusEditorApproval": 526,
	"./Shared/DropDownArticleStates/CureusEditorApproval.jsx": 526,
	"./Shared/DropDownArticleStates/CureusEditorApprovalDeferred": 527,
	"./Shared/DropDownArticleStates/CureusEditorApprovalDeferred.jsx": 527,
	"./Shared/DropDownArticleStates/DeskRejected": 530,
	"./Shared/DropDownArticleStates/DeskRejected.jsx": 530,
	"./Shared/DropDownArticleStates/Draft": 517,
	"./Shared/DropDownArticleStates/Draft.jsx": 517,
	"./Shared/DropDownArticleStates/EditorCheck": 520,
	"./Shared/DropDownArticleStates/EditorCheck.jsx": 520,
	"./Shared/DropDownArticleStates/EditorCheckDeferred": 521,
	"./Shared/DropDownArticleStates/EditorCheckDeferred.jsx": 521,
	"./Shared/DropDownArticleStates/EditorPreview": 518,
	"./Shared/DropDownArticleStates/EditorPreview.jsx": 518,
	"./Shared/DropDownArticleStates/EditorPreviewDeferred": 519,
	"./Shared/DropDownArticleStates/EditorPreviewDeferred.jsx": 519,
	"./Shared/DropDownArticleStates/InReview": 522,
	"./Shared/DropDownArticleStates/InReview.jsx": 522,
	"./Shared/DropDownArticleStates/Published": 529,
	"./Shared/DropDownArticleStates/Published.jsx": 529,
	"./Shared/DropDownArticleStates/ReviewsComplete": 523,
	"./Shared/DropDownArticleStates/ReviewsComplete.jsx": 523,
	"./Shared/Dropdown": 243,
	"./Shared/Dropdown.jsx": 243,
	"./Shared/DynamicJqueryTable": 38,
	"./Shared/DynamicJqueryTable.jsx": 38,
	"./Shared/FilterTab/Filter": 71,
	"./Shared/FilterTab/Filter.jsx": 71,
	"./Shared/FilterTab/FilterWrapper": 1543,
	"./Shared/FilterTab/FilterWrapper.jsx": 1543,
	"./Shared/FilterTab/Pill": 542,
	"./Shared/FilterTab/Pill.jsx": 542,
	"./Shared/LikeButton": 99,
	"./Shared/LikeButton.jsx": 99,
	"./Shared/List/List": 385,
	"./Shared/List/List.jsx": 385,
	"./Shared/Pagination/EllipsePage": 251,
	"./Shared/Pagination/EllipsePage.jsx": 251,
	"./Shared/Pagination/EllipsePages": 245,
	"./Shared/Pagination/EllipsePages.jsx": 245,
	"./Shared/Pagination/Page": 169,
	"./Shared/Pagination/Page.jsx": 169,
	"./Shared/Pagination/Pages": 20,
	"./Shared/Pagination/Pages.jsx": 20,
	"./Shared/PublishingStepButtons": 242,
	"./Shared/PublishingStepButtons.jsx": 242,
	"./Shared/RadioContainer": 62,
	"./Shared/RadioContainer.jsx": 62,
	"./Shared/SearchBar/SearchBar": 54,
	"./Shared/SearchBar/SearchBar.jsx": 54,
	"./Shared/SiqBadgeImage": 47,
	"./Shared/SiqBadgeImage.jsx": 47,
	"./Shared/SiqHover": 384,
	"./Shared/SiqHover.jsx": 384,
	"./Shared/SiqHoverWrapper": 534,
	"./Shared/SiqHoverWrapper.jsx": 534,
	"./Shared/Tabs": 152,
	"./Shared/Tabs.jsx": 152,
	"./Shared/TopAuthors": 244,
	"./Shared/TopAuthors.jsx": 244,
	"./Shared/TopContent": 540,
	"./Shared/TopContent.jsx": 540,
	"./Shared/Utility/Checkbox": 337,
	"./Shared/Utility/Checkbox.jsx": 337,
	"./Shared/Utility/ExportCSVButton": 89,
	"./Shared/Utility/ExportCSVButton.jsx": 89,
	"./Shared/Utility/LeafletMap/BottomBackButton": 369,
	"./Shared/Utility/LeafletMap/BottomBackButton.jsx": 369,
	"./Shared/Utility/LeafletMap/Channels/AddMarkers": 249,
	"./Shared/Utility/LeafletMap/Channels/AddMarkers.js": 249,
	"./Shared/Utility/LeafletMap/Channels/MarkersAndIcons": 61,
	"./Shared/Utility/LeafletMap/Channels/MarkersAndIcons.js": 61,
	"./Shared/Utility/LeafletMap/CreateMarker": 134,
	"./Shared/Utility/LeafletMap/CreateMarker.js": 134,
	"./Shared/Utility/LeafletMap/FullScreenButton": 370,
	"./Shared/Utility/LeafletMap/FullScreenButton.jsx": 370,
	"./Shared/Utility/LeafletMap/LeafletLoader": 248,
	"./Shared/Utility/LeafletMap/LeafletLoader.js": 248,
	"./Shared/Utility/LeafletMap/MapLegend": 202,
	"./Shared/Utility/LeafletMap/MapLegend.jsx": 202,
	"./Shared/Utility/LeafletMap/MapView": 237,
	"./Shared/Utility/LeafletMap/MapView.jsx": 237,
	"./Shared/Utility/SearchBar": 537,
	"./Shared/Utility/SearchBar.jsx": 537,
	"./Shared/Utility/TableDataFetcher": 368,
	"./Shared/Utility/TableDataFetcher.js": 368,
	"./SiqFooter": 1984,
	"./SiqFooter.js": 1984,
	"./SiqFooter/Main": 1985,
	"./SiqFooter/Main.jsx": 1985,
	"./SiqFooter/Siq": 1419,
	"./SiqFooter/Siq.jsx": 1419,
	"./SocialBoostCarousel/Main": 1544,
	"./SocialBoostCarousel/Main.jsx": 1544,
	"./SocialBoostCarousel/SocialBoostQuote": 468,
	"./SocialBoostCarousel/SocialBoostQuote.jsx": 468,
	"./SocialChannels": 1986,
	"./SocialChannels.js": 1986,
	"./SocialChannels/Button": 552,
	"./SocialChannels/Button.jsx": 552,
	"./SocialChannels/Main": 553,
	"./SocialChannels/Main.jsx": 553,
	"./Sortable": 21,
	"./Sortable.jsx": 21,
	"./Specialties/Main": 1987,
	"./Specialties/Main.jsx": 1987,
	"./Specialties/SpecialtyCard": 1420,
	"./Specialties/SpecialtyCard.jsx": 1420,
	"./StatsWidget": 1988,
	"./StatsWidget.js": 1988,
	"./StatsWidget/ActivityHistory": 1421,
	"./StatsWidget/ActivityHistory.jsx": 1421,
	"./StatsWidget/ApprovalEditorsByArticleCategory": 1422,
	"./StatsWidget/ApprovalEditorsByArticleCategory.jsx": 1422,
	"./StatsWidget/ArticlesModal": 1423,
	"./StatsWidget/ArticlesModal.jsx": 1423,
	"./StatsWidget/BarChart": 1424,
	"./StatsWidget/BarChart.jsx": 1424,
	"./StatsWidget/BarChartRow": 1184,
	"./StatsWidget/BarChartRow.jsx": 1184,
	"./StatsWidget/BarGraphWidget": 1183,
	"./StatsWidget/BarGraphWidget.jsx": 1183,
	"./StatsWidget/Chart": 1989,
	"./StatsWidget/Chart.jsx": 1989,
	"./StatsWidget/ClaimedArticles": 1430,
	"./StatsWidget/ClaimedArticles.jsx": 1430,
	"./StatsWidget/DateSelector": 15,
	"./StatsWidget/DateSelector.jsx": 15,
	"./StatsWidget/DeskSubmissions": 1432,
	"./StatsWidget/DeskSubmissions.jsx": 1432,
	"./StatsWidget/EditorTotals": 1433,
	"./StatsWidget/EditorTotals.jsx": 1433,
	"./StatsWidget/EditorialWidgetBody": 338,
	"./StatsWidget/EditorialWidgetBody.jsx": 338,
	"./StatsWidget/InvoicesWidget": 1180,
	"./StatsWidget/InvoicesWidget.jsx": 1180,
	"./StatsWidget/IterativeStatsWidget": 1182,
	"./StatsWidget/IterativeStatsWidget.jsx": 1182,
	"./StatsWidget/LineChart": 1426,
	"./StatsWidget/LineChart.jsx": 1426,
	"./StatsWidget/LineItemWidget": 1526,
	"./StatsWidget/LineItemWidget.jsx": 1526,
	"./StatsWidget/MatchedArticles": 1431,
	"./StatsWidget/MatchedArticles.jsx": 1431,
	"./StatsWidget/PieChart": 1427,
	"./StatsWidget/PieChart.jsx": 1427,
	"./StatsWidget/ProgressCard": 365,
	"./StatsWidget/ProgressCard.jsx": 365,
	"./StatsWidget/ProgressStats": 1429,
	"./StatsWidget/ProgressStats.jsx": 1429,
	"./StatsWidget/PublishedContentWidget": 1181,
	"./StatsWidget/PublishedContentWidget.jsx": 1181,
	"./StatsWidget/ScatterChart": 1428,
	"./StatsWidget/ScatterChart.jsx": 1428,
	"./StatsWidget/StackedBarChart": 1425,
	"./StatsWidget/StackedBarChart.jsx": 1425,
	"./StatsWidget/Table": 1990,
	"./StatsWidget/Table.jsx": 1990,
	"./StatsWidget/TableSelector": 1991,
	"./StatsWidget/TableSelector.jsx": 1991,
	"./StatsWidget/Widget": 567,
	"./StatsWidget/Widget.jsx": 567,
	"./StripeV2": 1992,
	"./StripeV2.js": 1992,
	"./StripeV2/Card": 562,
	"./StripeV2/Card.jsx": 562,
	"./StripeV2/ExpeditedPmcModal": 1102,
	"./StripeV2/ExpeditedPmcModal.jsx": 1102,
	"./StripeV2/Main": 174,
	"./StripeV2/Main.jsx": 174,
	"./StripeV2/Payment": 1103,
	"./StripeV2/Payment.jsx": 1103,
	"./StripeV2/PreferredEditingModal": 1101,
	"./StripeV2/PreferredEditingModal.jsx": 1101,
	"./StripeV2/PreferredLandingPage": 1104,
	"./StripeV2/PreferredLandingPage.jsx": 1104,
	"./StripeV2/SocialBoost": 1100,
	"./StripeV2/SocialBoost.jsx": 1100,
	"./StripeV2/SocialBoostLandingPage": 1105,
	"./StripeV2/SocialBoostLandingPage.jsx": 1105,
	"./SubmitRereview": 1993,
	"./SubmitRereview.js": 1993,
	"./TextAreaCounter": 1994,
	"./TextAreaCounter.jsx": 1994,
	"./TopicTool": 1995,
	"./TopicTool.jsx": 1995,
	"./Transloadit": 334,
	"./Transloadit.jsx": 334,
	"./TransloaditFileDrop": 173,
	"./TransloaditFileDrop.jsx": 173,
	"./TrendingTopics/AddModal": 290,
	"./TrendingTopics/AddModal.jsx": 290,
	"./TrendingTopics/Index": 286,
	"./TrendingTopics/Index.jsx": 286,
	"./TrendingTopics/Selected": 288,
	"./TrendingTopics/Selected.jsx": 288,
	"./TrendingTopics/Table": 287,
	"./TrendingTopics/Table.jsx": 287,
	"./TrendingTopics/Topic": 289,
	"./TrendingTopics/Topic.jsx": 289,
	"./UserMergeTool": 1996,
	"./UserMergeTool.js": 1996,
	"./UserMergeTool/Main": 1997,
	"./UserMergeTool/Main.jsx": 1997,
	"./UserMergeTool/Picker": 580,
	"./UserMergeTool/Picker.jsx": 580,
	"./UserMergeTool/UserDetails": 579,
	"./UserMergeTool/UserDetails.jsx": 579,
	"./UserPicker": 1998,
	"./UserPicker.js": 1998,
	"./UserPicker/DepartmentAutoSuggester": 153,
	"./UserPicker/DepartmentAutoSuggester.jsx": 153,
	"./UserPicker/Form": 124,
	"./UserPicker/Form.jsx": 124,
	"./UserPicker/InstitutionAutoSuggester": 154,
	"./UserPicker/InstitutionAutoSuggester.jsx": 154,
	"./UserPicker/Name": 979,
	"./UserPicker/Name.jsx": 979,
	"./UserProfile": 1545,
	"./UserProfile.js": 1545,
	"./UserProfile/Biography": 1546,
	"./UserProfile/Biography.jsx": 1546,
	"./UserProfile/ContentCard": 284,
	"./UserProfile/ContentCard.jsx": 284,
	"./UserProfile/Main": 1547,
	"./UserProfile/Main.jsx": 1547,
	"./UserProfile/SiqHover": 1548,
	"./UserProfile/SiqHover.jsx": 1548,
	"./UserProfileModals": 1549,
	"./UserProfileModals.js": 1549,
	"./UserProfileModals/AffiliationsMain": 469,
	"./UserProfileModals/AffiliationsMain.jsx": 469,
	"./UserProfileModals/AffiliationsRow": 470,
	"./UserProfileModals/AffiliationsRow.jsx": 470,
	"./UserProfileModals/EditAboutMe": 471,
	"./UserProfileModals/EditAboutMe.jsx": 471,
	"./UserProfileModals/EditInstitutionalEmail": 472,
	"./UserProfileModals/EditInstitutionalEmail.jsx": 472,
	"./UserProfileModals/EditProfile": 473,
	"./UserProfileModals/EditProfile.jsx": 473,
	"./UserProfileModals/Main": 1550,
	"./UserProfileModals/Main.jsx": 1550,
	"./UserProfileModals/Npi": 475,
	"./UserProfileModals/Npi.jsx": 475,
	"./UserProfileModals/NpiEdit": 476,
	"./UserProfileModals/NpiEdit.jsx": 476,
	"./UserProfileModals/NpiOther": 477,
	"./UserProfileModals/NpiOther.jsx": 477,
	"./UserProfileModals/NpiRegistered": 479,
	"./UserProfileModals/NpiRegistered.jsx": 479,
	"./UserProfileModals/NpiRows": 209,
	"./UserProfileModals/NpiRows.jsx": 209,
	"./UserProfileModals/NpiUs": 478,
	"./UserProfileModals/NpiUs.jsx": 478,
	"./UserProfileModals/PeerReviewPanel": 480,
	"./UserProfileModals/PeerReviewPanel.jsx": 480,
	"./UserProfileModals/PhoneNumber": 474,
	"./UserProfileModals/PhoneNumber.jsx": 474,
	"./UserProfileModals/PublicProfile": 481,
	"./UserProfileModals/PublicProfile.jsx": 481,
	"./UsersPage/Activities": 1551,
	"./UsersPage/Activities.jsx": 1551,
	"./UsersPage/Coauthors": 1552,
	"./UsersPage/Coauthors.jsx": 1552,
	"./WallOfShame/List": 1999,
	"./WallOfShame/List.jsx": 1999,
	"./WallOfShame/NewOrganizationModal": 1435,
	"./WallOfShame/NewOrganizationModal.jsx": 1435,
	"./WallOfShame/NewUserModal": 1436,
	"./WallOfShame/NewUserModal.jsx": 1436,
	"./WallOfShame/Organizations": 2000,
	"./WallOfShame/Organizations.jsx": 2000,
	"./WallOfShame/Users": 2001,
	"./WallOfShame/Users.jsx": 2001,
	"./WallOfShame/WallOfShameRow": 1434,
	"./WallOfShame/WallOfShameRow.jsx": 1434,
	"./useClickOutside": 49,
	"./useClickOutside.jsx": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2297;